// @generated drizzle-zero signature:sha256:49b4de73998607bf6572f6b309cae43cce432c428cfef53324667dd55528a879
// This file was automatically generated by drizzle-zero.
// You should NOT make any changes in this file as it will be overwritten.

import type { ReadonlyJSONValue, Row } from "@rocicorp/zero";
import { createBuilder } from "@rocicorp/zero";
import type { ZeroCustomType } from "drizzle-zero";
import type { default as zeroSchema } from "../db/drizzle-zero.config";

export type CommitDependenciesSourceCustomType = ZeroCustomType<
  typeof zeroSchema,
  "commitDependencies",
  "source"
>;
export type ConnectedAppsConfigurationCustomType = ZeroCustomType<
  typeof zeroSchema,
  "connectedApps",
  "configuration"
>;
export type ConnectedAppsMetadataCustomType = ZeroCustomType<
  typeof zeroSchema,
  "connectedApps",
  "metadata"
>;
export type NetworksConfigurationCustomType = ZeroCustomType<
  typeof zeroSchema,
  "networks",
  "configuration"
>;
export type NetworksDestinationsCustomType = ZeroCustomType<
  typeof zeroSchema,
  "networks",
  "destinations"
>;
export type NetworksMetadataCustomType = ZeroCustomType<
  typeof zeroSchema,
  "networks",
  "metadata"
>;
export type RolePermissionsPermissionCustomType = ZeroCustomType<
  typeof zeroSchema,
  "rolePermissions",
  "permission"
>;
export type SkillGitSourcesCatalogCustomType = ZeroCustomType<
  typeof zeroSchema,
  "skillGitSources",
  "catalog"
>;
export type SpacesNameCustomType = ZeroCustomType<
  typeof zeroSchema,
  "spaces",
  "name"
>;
export type SpacesSlugCustomType = ZeroCustomType<
  typeof zeroSchema,
  "spaces",
  "slug"
>;
export type UserNameCustomType = ZeroCustomType<
  typeof zeroSchema,
  "user",
  "name"
>;

const aiBudgetsTable = {
  name: "aiBudgets",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    scopeKind: {
      type: "string",
      optional: false,
      customType: null as unknown as "space" | "tenant" | "ai_provider",
      serverName: "scope_kind",
    },
    scopeId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "scope_id",
    },
    aiProviderId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "ai_provider_id",
    },
    limitAmount: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "limit_amount",
    },
    productivityHourlyRate: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "productivity_hourly_rate",
    },
    warnThresholdPct: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "warn_threshold_pct",
    },
    createdAt: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "created_at",
    },
    updatedAt: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "updated_at",
    },
    tenantId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "tenant_id",
    },
  },
  primaryKey: ["id"],
  serverName: "ai_budgets",
} as const;
const aiModelPricingTable = {
  name: "aiModelPricing",
  columns: {
    aiProviderId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "ai_provider_id",
    },
    modelId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "model_id",
    },
    inputPerMillion: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "input_per_million",
    },
    outputPerMillion: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "output_per_million",
    },
    cacheReadPerMillion: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "cache_read_per_million",
    },
    cacheWritePerMillion: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "cache_write_per_million",
    },
    updatedAt: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "updated_at",
    },
    tenantId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "tenant_id",
    },
  },
  primaryKey: ["aiProviderId", "modelId"],
  serverName: "ai_model_pricing",
} as const;
const aiProvidersTable = {
  name: "aiProviders",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    active: {
      type: "boolean",
      optional: true,
      customType: null as unknown as boolean,
    },
    provider: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
    },
    baseUrl: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "base_url",
    },
    chatModel: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "chat_model",
    },
    fastModel: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "fast_model",
    },
    effort: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
    },
    disabledAt: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "disabled_at",
    },
    createdAt: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "created_at",
    },
    updatedAt: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "updated_at",
    },
    tenantId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "tenant_id",
    },
  },
  primaryKey: ["id"],
  serverName: "ai_providers",
} as const;
const aiUsageDailyTable = {
  name: "aiUsageDaily",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    day: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
    },
    source: {
      type: "string",
      optional: false,
      customType: null as unknown as
        | "autotune"
        | "autofix"
        | "personal_chat"
        | "workflow_builder"
        | "workflow_run"
        | "branch_name"
        | "chat_name"
        | "workflow_name"
        | "step_test_name"
        | "commit_message"
        | "chat_recap"
        | "summarize"
        | "context_recovery"
        | "context_compaction"
        | "workflow_value"
        | "duplicate_detection",
    },
    provider: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    model: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    aiProviderId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "ai_provider_id",
    },
    connectorId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "connector_id",
    },
    workflowId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "workflow_id",
    },
    inputTokens: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "input_tokens",
    },
    outputTokens: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "output_tokens",
    },
    cacheReadTokens: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "cache_read_tokens",
    },
    cacheWriteTokens: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "cache_write_tokens",
    },
    requestCount: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "request_count",
    },
    tenantId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "tenant_id",
    },
  },
  primaryKey: ["id"],
  serverName: "ai_usage_daily",
} as const;
const apikeyTable = {
  name: "apikey",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    configId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "config_id",
    },
    name: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
    },
    start: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
    },
    prefix: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
    },
    referenceId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "reference_id",
    },
    enabled: {
      type: "boolean",
      optional: true,
      customType: null as unknown as boolean,
    },
    lastRequest: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "last_request",
    },
    expiresAt: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "expires_at",
    },
    createdAt: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "created_at",
    },
    updatedAt: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "updated_at",
    },
    spaceId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "space_id",
    },
    serviceAccountId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "service_account_id",
    },
    tenantId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "tenant_id",
    },
  },
  primaryKey: ["id"],
} as const;
const assistantMessagesTable = {
  name: "assistantMessages",
  columns: {
    entryId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "entry_id",
    },
    text: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    tenantId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "tenant_id",
    },
  },
  primaryKey: ["entryId"],
  serverName: "assistant_messages",
} as const;
const assistantReasoningsTable = {
  name: "assistantReasonings",
  columns: {
    entryId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "entry_id",
    },
    text: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    signature: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    durationMs: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "duration_ms",
    },
    tenantId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "tenant_id",
    },
  },
  primaryKey: ["entryId"],
  serverName: "assistant_reasonings",
} as const;
const attachmentsTable = {
  name: "attachments",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    entryId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "entry_id",
    },
    fileName: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "file_name",
    },
    mediaType: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "media_type",
    },
    sizeBytes: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "size_bytes",
    },
    tenantId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "tenant_id",
    },
  },
  primaryKey: ["id"],
} as const;
const auditLogDestinationsTable = {
  name: "auditLogDestinations",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    name: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    url: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    method: {
      type: "string",
      optional: false,
      customType: null as unknown as "PUT" | "POST",
    },
    connectedAppId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "connected_app_id",
    },
    cursorTimestamp: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "cursor_timestamp",
    },
    lastError: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "last_error",
    },
    testingStartedAt: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "testing_started_at",
    },
    tenantId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "tenant_id",
    },
  },
  primaryKey: ["id"],
  serverName: "audit_log_destinations",
} as const;
const auditLogsTable = {
  name: "auditLogs",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    timestamp: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
    },
    userId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "user_id",
    },
    operationName: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "operation_name",
    },
    inputs: {
      type: "json",
      optional: false,
      customType: null as unknown as ReadonlyJSONValue,
    },
    output: {
      type: "json",
      optional: true,
      customType: null as unknown as ReadonlyJSONValue,
    },
    success: {
      type: "boolean",
      optional: false,
      customType: null as unknown as boolean,
    },
    error: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
    },
    ipAddress: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "ip_address",
    },
    userAgent: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "user_agent",
    },
    source: {
      type: "string",
      optional: false,
      customType: null as unknown as
        | "api"
        | "ui"
        | "scim"
        | "jit"
        | "mcp"
        | "federation"
        | "device"
        | "internal",
    },
    tenantId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "tenant_id",
    },
  },
  primaryKey: ["id"],
  serverName: "audit_logs",
} as const;
const blobsTable = {
  name: "blobs",
  columns: {
    hash: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    content: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    tenantId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "tenant_id",
    },
  },
  primaryKey: ["hash", "tenantId"],
} as const;
const branchContributorsTable = {
  name: "branchContributors",
  columns: {
    branchId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "branch_id",
    },
    workflowId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "workflow_id",
    },
    userId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "user_id",
    },
    lastMessagedAt: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "last_messaged_at",
    },
    tenantId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "tenant_id",
    },
  },
  primaryKey: ["branchId", "userId"],
  serverName: "branch_contributors",
} as const;
const branchModelPreferencesTable = {
  name: "branchModelPreferences",
  columns: {
    branchId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "branch_id",
    },
    userId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "user_id",
    },
    aiProviderId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "ai_provider_id",
    },
    tenantId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "tenant_id",
    },
  },
  primaryKey: ["branchId", "userId"],
  serverName: "branch_model_preferences",
} as const;
const buildCachesTable = {
  name: "buildCaches",
  columns: {
    inputHash: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "input_hash",
    },
    hashes: {
      type: "json",
      optional: false,
      customType: null as unknown as string[],
    },
    builtForInputHash: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "built_for_input_hash",
    },
    createdAt: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "created_at",
    },
  },
  primaryKey: ["inputHash"],
  serverName: "build_caches",
} as const;
const chatEntriesTable = {
  name: "chatEntries",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    chatId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "chat_id",
    },
    entryType: {
      type: "string",
      optional: false,
      customType: null as unknown as
        | "UserMessage"
        | "AssistantMessage"
        | "AssistantReasoning"
        | "AssistantToolUse"
        | "SystemMessage"
        | "UserInterrupt"
        | "UserAction"
        | "Compaction",
      serverName: "entry_type",
    },
    createdAt: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "created_at",
    },
    previousEntryId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "previous_entry_id",
    },
    streaming: {
      type: "boolean",
      optional: true,
      customType: null as unknown as boolean,
    },
    generationId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "generation_id",
    },
    tenantId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "tenant_id",
    },
  },
  primaryKey: ["id"],
  serverName: "chat_entries",
} as const;
const chatsTable = {
  name: "chats",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    commitId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "commit_id",
    },
    createdAt: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "created_at",
    },
    lastChatEntryType: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "last_chat_entry_type",
    },
    respondingAt: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "responding_at",
    },
    lastLoopHeartbeatAt: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "last_loop_heartbeat_at",
    },
    awaitingAction: {
      type: "boolean",
      optional: true,
      customType: null as unknown as boolean,
      serverName: "awaiting_action",
    },
    tenantId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "tenant_id",
    },
  },
  primaryKey: ["id"],
} as const;
const commitConnectedAppsTable = {
  name: "commitConnectedApps",
  columns: {
    commitId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "commit_id",
    },
    stepDir: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "step_dir",
    },
    connectedAppId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "connected_app_id",
    },
    workflowId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "workflow_id",
    },
    color: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    tenantId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "tenant_id",
    },
  },
  primaryKey: ["commitId", "connectedAppId", "stepDir"],
  serverName: "commit_connected_apps",
} as const;
const commitDependenciesTable = {
  name: "commitDependencies",
  columns: {
    commitId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "commit_id",
    },
    stepDir: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "step_dir",
    },
    source: {
      type: "string",
      optional: false,
      customType: null as unknown as CommitDependenciesSourceCustomType,
    },
    name: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    version: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
    },
    tenantId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "tenant_id",
    },
  },
  primaryKey: ["commitId", "name", "source", "stepDir"],
  serverName: "commit_dependencies",
} as const;
const commitEmailAddressesTable = {
  name: "commitEmailAddresses",
  columns: {
    commitId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "commit_id",
    },
    localPart: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "local_part",
    },
    stepDir: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "step_dir",
    },
    tenantId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "tenant_id",
    },
  },
  primaryKey: ["commitId", "localPart"],
  serverName: "commit_email_addresses",
} as const;
const commitFilesTable = {
  name: "commitFiles",
  columns: {
    commitId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "commit_id",
    },
    path: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    blobHash: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "blob_hash",
    },
    tenantId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "tenant_id",
    },
  },
  primaryKey: ["commitId", "path"],
  serverName: "commit_files",
} as const;
const commitLinksTable = {
  name: "commitLinks",
  columns: {
    commitId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "commit_id",
    },
    fromStep: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "from_step",
    },
    toStep: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "to_step",
    },
    tenantId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "tenant_id",
    },
  },
  primaryKey: ["commitId", "fromStep", "toStep"],
  serverName: "commit_links",
} as const;
const commitRoutesTable = {
  name: "commitRoutes",
  columns: {
    commitId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "commit_id",
    },
    route: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    stepDir: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "step_dir",
    },
    routeType: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "route_type",
    },
    routeAuth: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "route_auth",
    },
    externalId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "external_id",
    },
    title: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
    },
    tenantId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "tenant_id",
    },
  },
  primaryKey: ["commitId", "route"],
  serverName: "commit_routes",
} as const;
const commitSchedulesTable = {
  name: "commitSchedules",
  columns: {
    commitId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "commit_id",
    },
    stepDir: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "step_dir",
    },
    cronExpression: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "cron_expression",
    },
    nextRunAt: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "next_run_at",
    },
    tenantId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "tenant_id",
    },
  },
  primaryKey: ["commitId", "stepDir"],
  serverName: "commit_schedules",
} as const;
const commitStepLayersTable = {
  name: "commitStepLayers",
  columns: {
    commitId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "commit_id",
    },
    stepDir: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "step_dir",
    },
    version: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
    },
    contentHash: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "content_hash",
    },
    layers: {
      type: "json",
      optional: false,
      customType: null as unknown as {
        hash: string;
        cacheOutputs?: string[];
      }[],
    },
    tenantId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "tenant_id",
    },
  },
  primaryKey: ["commitId", "stepDir"],
  serverName: "commit_step_layers",
} as const;
const compactionsTable = {
  name: "compactions",
  columns: {
    entryId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "entry_id",
    },
    text: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    throughEntryId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "through_entry_id",
    },
    tenantId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "tenant_id",
    },
  },
  primaryKey: ["entryId"],
  serverName: "chat_compactions",
} as const;
const connectedAppUsagesTable = {
  name: "connectedAppUsages",
  columns: {
    connectedAppId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "connected_app_id",
    },
    type: {
      type: "string",
      optional: false,
      customType: null as unknown as
        | "personal_chat"
        | "workflow_slug"
        | "commit_step"
        | "workflow_chat"
        | "space_git_remote"
        | "skill_git_source"
        | "audit_log_destination"
        | "ai_provider",
    },
    refId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "ref_id",
    },
    subKey: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "sub_key",
    },
    createdAt: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "created_at",
    },
    tenantId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "tenant_id",
    },
  },
  primaryKey: ["connectedAppId", "refId", "subKey", "type"],
  serverName: "connected_app_usages",
} as const;
const connectedAppsTable = {
  name: "connectedApps",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    name: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    identifier: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    urlPattern: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "url_pattern",
    },
    configuration: {
      type: "json",
      optional: false,
      customType: null as unknown as ConnectedAppsConfigurationCustomType,
    },
    secretKeys: {
      type: "json",
      optional: true,
      customType: null as unknown as string[],
      serverName: "secret_keys",
    },
    metadata: {
      type: "json",
      optional: false,
      customType: null as unknown as ConnectedAppsMetadataCustomType,
    },
    oauthConnectionId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "oauth_connection_id",
    },
    createdAt: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "created_at",
    },
    createdByUserId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "created_by_user_id",
    },
    createdByServiceAccountId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "created_by_service_account_id",
    },
    fresh: {
      type: "boolean",
      optional: false,
      customType: null as unknown as boolean,
    },
    lastTestAt: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "last_test_at",
    },
    lastTestStatus: {
      type: "string",
      optional: true,
      customType: null as unknown as "pending" | "success" | "failure",
      serverName: "last_test_status",
    },
    lastTestMessage: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "last_test_message",
    },
    note: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
    },
    backingWorkflowId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "backing_workflow_id",
    },
    tenantId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "tenant_id",
    },
  },
  primaryKey: ["id"],
  serverName: "connected_apps",
} as const;
const connectionClaimsTable = {
  name: "connectionClaims",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    workflowId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "workflow_id",
    },
    branchId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "branch_id",
    },
    stepDir: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "step_dir",
    },
    targetUrl: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "target_url",
    },
    search: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
    },
    createdByUserId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "created_by_user_id",
    },
    createdByServiceAccountId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "created_by_service_account_id",
    },
    status: {
      type: "string",
      optional: false,
      customType: null as unknown as "pending" | "resolved" | "dismissed",
    },
    connectedAppId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "connected_app_id",
    },
    createdAt: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "created_at",
    },
    expiresAt: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "expires_at",
    },
    tenantId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "tenant_id",
    },
  },
  primaryKey: ["id"],
  serverName: "connection_claims",
} as const;
const connectorUsageBudgetsTable = {
  name: "connectorUsageBudgets",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    spaceId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "space_id",
    },
    connectorId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "connector_id",
    },
    measure: {
      type: "string",
      optional: false,
      customType: null as unknown as "requests" | "tokens" | "spend_usd",
    },
    limitAmount: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "limit_amount",
    },
    warnThresholdPct: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "warn_threshold_pct",
    },
    createdAt: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "created_at",
    },
    updatedAt: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "updated_at",
    },
    tenantId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "tenant_id",
    },
  },
  primaryKey: ["id"],
  serverName: "connector_usage_budgets",
} as const;
const connectorUsageDimensionsTable = {
  name: "connectorUsageDimensions",
  columns: {
    connectorId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "connector_id",
    },
    measure: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    dimension: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    tenantId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "tenant_id",
    },
  },
  primaryKey: ["connectorId", "dimension", "measure", "tenantId"],
  serverName: "connector_usage_dimensions",
} as const;
const connectorUsagePricesTable = {
  name: "connectorUsagePrices",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    spaceId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "space_id",
    },
    connectorId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "connector_id",
    },
    measure: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    dimension: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
    },
    amountPerUnit: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "amount_per_unit",
    },
    createdAt: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "created_at",
    },
    updatedAt: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "updated_at",
    },
    tenantId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "tenant_id",
    },
  },
  primaryKey: ["id"],
  serverName: "connector_usage_prices",
} as const;
const designsTable = {
  name: "designs",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    name: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    primaryColor: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "primary_color",
    },
    accentColor: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "accent_color",
    },
    font: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    corners: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    theme: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    style: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
    },
    createdAt: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "created_at",
    },
    updatedAt: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "updated_at",
    },
    createdByUserId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "created_by_user_id",
    },
    createdByServiceAccountId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "created_by_service_account_id",
    },
    tenantId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "tenant_id",
    },
  },
  primaryKey: ["id"],
} as const;
const duplicateDetectionRunsTable = {
  name: "duplicateDetectionRuns",
  columns: {
    tenantId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "tenant_id",
    },
    startedAt: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "started_at",
    },
    completedAt: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "completed_at",
    },
  },
  primaryKey: ["tenantId"],
  serverName: "duplicate_detection_runs",
} as const;
const duplicateWorkflowPairsTable = {
  name: "duplicateWorkflowPairs",
  columns: {
    workflowAId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "workflow_a_id",
    },
    workflowBId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "workflow_b_id",
    },
    verdict: {
      type: "string",
      optional: false,
      customType: null as unknown as "duplicate" | "distinct",
    },
    reason: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
    },
    workflowAPurpose: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "workflow_a_purpose",
    },
    workflowBPurpose: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "workflow_b_purpose",
    },
    contentHash: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "content_hash",
    },
    judgedAt: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "judged_at",
    },
    tenantId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "tenant_id",
    },
  },
  primaryKey: ["workflowAId", "workflowBId"],
  serverName: "duplicate_workflow_pairs",
} as const;
const duplicateWorkflowReviewsTable = {
  name: "duplicateWorkflowReviews",
  columns: {
    workflowAId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "workflow_a_id",
    },
    workflowBId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "workflow_b_id",
    },
    decision: {
      type: "string",
      optional: false,
      customType: null as unknown as "same" | "different",
    },
    reviewedByUserId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "reviewed_by_user_id",
    },
    reviewedAt: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "reviewed_at",
    },
    tenantId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "tenant_id",
    },
  },
  primaryKey: ["workflowAId", "workflowBId"],
  serverName: "duplicate_workflow_reviews",
} as const;
const egressRoutesTable = {
  name: "egressRoutes",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    networkId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "network_id",
    },
    destinationType: {
      type: "string",
      optional: false,
      customType: null as unknown as "cidr" | "hostnameGlob",
      serverName: "destination_type",
    },
    destination: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    enforced: {
      type: "boolean",
      optional: true,
      customType: null as unknown as boolean,
    },
    createdAt: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "created_at",
    },
    disabledAt: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "disabled_at",
    },
    tenantId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "tenant_id",
    },
  },
  primaryKey: ["id"],
  serverName: "egress_routes",
} as const;
const egressRulesTable = {
  name: "egressRules",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    destinationType: {
      type: "string",
      optional: false,
      customType: null as unknown as "cidr" | "hostnameGlob",
      serverName: "destination_type",
    },
    destination: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    port: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
    },
    action: {
      type: "string",
      optional: false,
      customType: null as unknown as "allow" | "deny",
    },
    createdAt: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "created_at",
    },
    disabledAt: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "disabled_at",
    },
    tenantId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "tenant_id",
    },
  },
  primaryKey: ["id"],
  serverName: "egress_rules",
} as const;
const executionStatsTable = {
  name: "executionStats",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    bucketAt: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "bucket_at",
    },
    spaceId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "space_id",
    },
    workflowId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "workflow_id",
    },
    source: {
      type: "string",
      optional: true,
      customType: null as unknown as
        | "connector"
        | "workflow"
        | "chat"
        | "git_sync"
        | "other",
    },
    billingQuantumMs: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "billing_quantum_ms",
    },
    runCount: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "run_count",
    },
    buildCount: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "build_count",
    },
    errorCount: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "error_count",
    },
    computeMs: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "compute_ms",
    },
    billableComputeMs: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "billable_compute_ms",
    },
    usedSlotMs: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "used_slot_ms",
    },
    wantedSlotMs: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "wanted_slot_ms",
    },
    shortfallSlotMs: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "shortfall_slot_ms",
    },
    burstSlotMs: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "burst_slot_ms",
    },
    observedMs: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "observed_ms",
    },
    maximumActiveSlots: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "maximum_active_slots",
    },
    currentActiveSlots: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "current_active_slots",
    },
    currentWantedSlots: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "current_wanted_slots",
    },
    promisedSlots: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "promised_slots",
    },
    maximumSlots: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "maximum_slots",
    },
    updatedAt: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "updated_at",
    },
    tenantId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "tenant_id",
    },
  },
  primaryKey: ["id"],
  serverName: "execution_stats",
} as const;
const featureFlagsTable = {
  name: "featureFlags",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    name: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    createdAt: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "created_at",
    },
    updatedAt: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "updated_at",
    },
    enabledAt: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "enabled_at",
    },
    createdByUserId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "created_by_user_id",
    },
    createdByServiceAccountId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "created_by_service_account_id",
    },
    tenantId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "tenant_id",
    },
  },
  primaryKey: ["id"],
  serverName: "feature_flags",
} as const;
const gitBranchCursorsTable = {
  name: "gitBranchCursors",
  columns: {
    spaceId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "space_id",
    },
    gitBranchName: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "git_branch_name",
    },
    lastSyncedTreeHash: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "last_synced_tree_hash",
    },
    lastSyncedGitOid: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "last_synced_git_oid",
    },
    tenantId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "tenant_id",
    },
  },
  primaryKey: ["gitBranchName", "spaceId"],
  serverName: "git_branch_cursors",
} as const;
const grantRequestGrantsTable = {
  name: "grantRequestGrants",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    requestId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "request_id",
    },
    userGroupId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "user_group_id",
    },
    userId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "user_id",
    },
    serviceAccountId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "service_account_id",
    },
    builtinRoleId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "builtin_role_id",
    },
    customRoleId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "custom_role_id",
    },
    tenantId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "tenant_id",
    },
  },
  primaryKey: ["id"],
  serverName: "grant_request_grants",
} as const;
const grantRequestsTable = {
  name: "grantRequests",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    scopeId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "scope_id",
    },
    scopeKind: {
      type: "string",
      optional: false,
      customType: null as unknown as
        | "space"
        | "connected_app"
        | "skill"
        | "network"
        | "service_account",
      serverName: "scope_kind",
    },
    note: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
    },
    requestedByUserId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "requested_by_user_id",
    },
    createdAt: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "created_at",
    },
    tenantId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "tenant_id",
    },
  },
  primaryKey: ["id"],
  serverName: "grant_requests",
} as const;
const networkUsageBucketsTable = {
  name: "networkUsageBuckets",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    bucketAt: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "bucket_at",
    },
    spaceId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "space_id",
    },
    workflowId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "workflow_id",
    },
    source: {
      type: "string",
      optional: false,
      customType: null as unknown as
        | "connector"
        | "workflow"
        | "chat"
        | "git_sync"
        | "other",
    },
    surface: {
      type: "string",
      optional: false,
      customType: null as unknown as "public" | "sandbox" | "api",
    },
    egressBytes: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "egress_bytes",
    },
    ingressBytes: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "ingress_bytes",
    },
    updatedAt: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "updated_at",
    },
    tenantId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "tenant_id",
    },
  },
  primaryKey: ["id"],
  serverName: "network_usage_buckets",
} as const;
const networksTable = {
  name: "networks",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    name: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    identifier: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    configuration: {
      type: "json",
      optional: false,
      customType: null as unknown as NetworksConfigurationCustomType,
    },
    destinations: {
      type: "json",
      optional: false,
      customType: null as unknown as NetworksDestinationsCustomType,
    },
    metadata: {
      type: "json",
      optional: false,
      customType: null as unknown as NetworksMetadataCustomType,
    },
    createdAt: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "created_at",
    },
    createdByUserId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "created_by_user_id",
    },
    createdByServiceAccountId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "created_by_service_account_id",
    },
    lastTestAt: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "last_test_at",
    },
    lastTestStatus: {
      type: "string",
      optional: true,
      customType: null as unknown as "pending" | "success" | "failure",
      serverName: "last_test_status",
    },
    lastTestMessage: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "last_test_message",
    },
    disabledAt: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "disabled_at",
    },
    enforced: {
      type: "boolean",
      optional: true,
      customType: null as unknown as boolean,
    },
    tenantId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "tenant_id",
    },
  },
  primaryKey: ["id"],
} as const;
const oauthClientTable = {
  name: "oauthClient",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    name: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    redirectUris: {
      type: "json",
      optional: false,
      customType: null as unknown as string[],
      serverName: "redirect_uris",
    },
    grantTypes: {
      type: "json",
      optional: false,
      customType: null as unknown as string[],
      serverName: "grant_types",
    },
    scopes: {
      type: "json",
      optional: true,
      customType: null as unknown as string[],
    },
    clientIdUrl: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "client_id_url",
    },
    resourceKind: {
      type: "string",
      optional: true,
      customType: null as unknown as "api" | "mcp",
      serverName: "resource_kind",
    },
    tokenEndpointAuthMethod: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "token_endpoint_auth_method",
    },
    disabled: {
      type: "boolean",
      optional: true,
      customType: null as unknown as boolean,
    },
    createdAt: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "created_at",
    },
    updatedAt: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "updated_at",
    },
    tenantId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "tenant_id",
    },
  },
  primaryKey: ["id"],
  serverName: "oauth_client",
} as const;
const oauthClientServiceAccountTable = {
  name: "oauthClientServiceAccount",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    clientId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "client_id",
    },
    serviceAccountId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "service_account_id",
    },
    createdByUserId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "created_by_user_id",
    },
    createdAt: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "created_at",
    },
    tenantId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "tenant_id",
    },
  },
  primaryKey: ["id"],
  serverName: "oauth_client_service_account",
} as const;
const oauthConnectionsTable = {
  name: "oauthConnections",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    provider: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    clientId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "client_id",
    },
    hasClientSecret: {
      type: "boolean",
      optional: true,
      customType: null as unknown as boolean,
      serverName: "has_client_secret",
    },
    scopes: {
      type: "json",
      optional: false,
      customType: null as unknown as string[],
    },
    tokenType: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "token_type",
    },
    accessTokenExpiresAt: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "access_token_expires_at",
    },
    refreshTokenExpiresAt: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "refresh_token_expires_at",
    },
    status: {
      type: "string",
      optional: false,
      customType: null as unknown as
        | "not_connected"
        | "obtained_code"
        | "connected"
        | "error",
    },
    lastError: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "last_error",
    },
    createdAt: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "created_at",
    },
    updatedAt: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "updated_at",
    },
    tenantId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "tenant_id",
    },
  },
  primaryKey: ["id"],
  serverName: "oauth_connections",
} as const;
const oauthGrantTable = {
  name: "oauthGrant",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    userId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "user_id",
    },
    ssoProviderId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "sso_provider_id",
    },
    ssoProviderUpdatedAt: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "sso_provider_updated_at",
    },
    serviceAccountId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "service_account_id",
    },
    clientId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "client_id",
    },
    resource: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    scopes: {
      type: "json",
      optional: false,
      customType: null as unknown as string[],
    },
    refreshTokenExpiresAt: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "refresh_token_expires_at",
    },
    createdAt: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "created_at",
    },
    updatedAt: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "updated_at",
    },
    lastUsedAt: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "last_used_at",
    },
    revokedAt: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "revoked_at",
    },
    tenantId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "tenant_id",
    },
  },
  primaryKey: ["id"],
  serverName: "oauth_grant",
} as const;
const oidcProvidersTable = {
  name: "oidcProviders",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    name: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    issuer: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    audience: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    jwksUri: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "jwks_uri",
    },
    disabled: {
      type: "boolean",
      optional: true,
      customType: null as unknown as boolean,
    },
    createdByUserId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "created_by_user_id",
    },
    createdByServiceAccountId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "created_by_service_account_id",
    },
    createdAt: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "created_at",
    },
    updatedAt: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "updated_at",
    },
    tenantId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "tenant_id",
    },
  },
  primaryKey: ["id"],
  serverName: "oidc_providers",
} as const;
const personalChatConnectedAppsTable = {
  name: "personalChatConnectedApps",
  columns: {
    personalChatId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "personal_chat_id",
    },
    connectedAppId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "connected_app_id",
    },
    createdAt: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "created_at",
    },
    tenantId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "tenant_id",
    },
  },
  primaryKey: ["connectedAppId", "personalChatId"],
  serverName: "personal_chat_connected_apps",
} as const;
const personalChatsTable = {
  name: "personalChats",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    chatId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "chat_id",
    },
    userId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "user_id",
    },
    name: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    createdAt: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "created_at",
    },
    closedAt: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "closed_at",
    },
    lastActiveAt: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "last_active_at",
    },
    derivedWorkflowId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "derived_workflow_id",
    },
    position: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
    },
    pinnedAt: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "pinned_at",
    },
    tenantId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "tenant_id",
    },
  },
  primaryKey: ["id"],
  serverName: "personal_chats",
} as const;
const personalVolumesTable = {
  name: "personalVolumes",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    volumeId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "volume_id",
    },
    userId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "user_id",
    },
    name: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    createdAt: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "created_at",
    },
    tenantId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "tenant_id",
    },
  },
  primaryKey: ["id"],
  serverName: "personal_volumes",
} as const;
const roleGrantsTable = {
  name: "roleGrants",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    userGroupId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "user_group_id",
    },
    userId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "user_id",
    },
    serviceAccountId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "service_account_id",
    },
    builtinRoleId: {
      type: "string",
      optional: true,
      customType: null as unknown as
        | "tenant_admin"
        | "space_manager"
        | "space_editor"
        | "space_viewer"
        | "connected_app_editor"
        | "connected_app_sharer"
        | "connected_app_user"
        | "connected_app_viewer"
        | "skill_manager"
        | "skill_user"
        | "network_manager"
        | "network_user"
        | "network_viewer"
        | "user_group_manager"
        | "user_group_member"
        | "service_account_manager"
        | "service_account_user"
        | "service_account_viewer"
        | "app_creator"
        | "skill_creator"
        | "space_creator"
        | "network_creator"
        | "user_group_creator"
        | "service_account_creator"
        | "connector_sharer"
        | "oidc_provider_manager"
        | "space_manager_all",
      serverName: "builtin_role_id",
    },
    customRoleId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "custom_role_id",
    },
    scopeId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "scope_id",
    },
    createdAt: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "created_at",
    },
    tenantId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "tenant_id",
    },
  },
  primaryKey: ["id"],
  serverName: "role_grants",
} as const;
const rolePermissionsTable = {
  name: "rolePermissions",
  columns: {
    roleId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "role_id",
    },
    permission: {
      type: "string",
      optional: false,
      customType: null as unknown as RolePermissionsPermissionCustomType,
    },
    tenantId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "tenant_id",
    },
  },
  primaryKey: ["permission", "roleId"],
  serverName: "role_permissions",
} as const;
const rolesTable = {
  name: "roles",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    name: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    scopeKind: {
      type: "string",
      optional: false,
      customType: null as unknown as
        | "space"
        | "connected_app"
        | "skill"
        | "network"
        | "user_group"
        | "service_account"
        | "oidc_provider"
        | "tenant",
      serverName: "scope_kind",
    },
    createdAt: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "created_at",
    },
    updatedAt: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "updated_at",
    },
    tenantId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "tenant_id",
    },
  },
  primaryKey: ["id"],
} as const;
const routeFavoritesTable = {
  name: "routeFavorites",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    userId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "user_id",
    },
    workflowId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "workflow_id",
    },
    stepDir: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "step_dir",
    },
    createdAt: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "created_at",
    },
    tenantId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "tenant_id",
    },
  },
  primaryKey: ["id"],
  serverName: "route_favorites",
} as const;
const routeViewsTable = {
  name: "routeViews",
  columns: {
    workflowId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "workflow_id",
    },
    userId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "user_id",
    },
    stepDir: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "step_dir",
    },
    lastSeenAt: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "last_seen_at",
    },
    tenantId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "tenant_id",
    },
  },
  primaryKey: ["stepDir", "userId", "workflowId"],
  serverName: "route_views",
} as const;
const serviceAccountFederationsTable = {
  name: "serviceAccountFederations",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    serviceAccountId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "service_account_id",
    },
    providerId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "provider_id",
    },
    name: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    subject: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    disabled: {
      type: "boolean",
      optional: true,
      customType: null as unknown as boolean,
    },
    createdByUserId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "created_by_user_id",
    },
    createdByServiceAccountId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "created_by_service_account_id",
    },
    createdAt: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "created_at",
    },
    updatedAt: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "updated_at",
    },
    lastUsedAt: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "last_used_at",
    },
    tenantId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "tenant_id",
    },
  },
  primaryKey: ["id"],
  serverName: "service_account_federations",
} as const;
const serviceAccountsTable = {
  name: "serviceAccounts",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    name: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    description: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
    },
    disabled: {
      type: "boolean",
      optional: true,
      customType: null as unknown as boolean,
    },
    createdByUserId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "created_by_user_id",
    },
    createdByServiceAccountId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "created_by_service_account_id",
    },
    createdAt: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "created_at",
    },
    updatedAt: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "updated_at",
    },
    tenantId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "tenant_id",
    },
  },
  primaryKey: ["id"],
  serverName: "service_accounts",
} as const;
const skillFilesTable = {
  name: "skillFiles",
  columns: {
    skillId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "skill_id",
    },
    path: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    blobHash: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "blob_hash",
    },
    tenantId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "tenant_id",
    },
  },
  primaryKey: ["path", "skillId"],
  serverName: "skill_files",
} as const;
const skillGitInstallationsTable = {
  name: "skillGitInstallations",
  columns: {
    skillId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "skill_id",
    },
    sourceId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "source_id",
    },
    sourcePath: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "source_path",
    },
    lastSyncedCommit: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "last_synced_commit",
    },
    syncStartedAt: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "sync_started_at",
    },
    lastSyncedAt: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "last_synced_at",
    },
    lastError: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "last_error",
    },
    tenantId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "tenant_id",
    },
  },
  primaryKey: ["skillId"],
  serverName: "skill_git_installations",
} as const;
const skillGitSourcesTable = {
  name: "skillGitSources",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    remoteUrl: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "remote_url",
    },
    ref: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
    },
    subpath: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
    },
    connectedAppId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "connected_app_id",
    },
    catalog: {
      type: "json",
      optional: false,
      customType: null as unknown as SkillGitSourcesCatalogCustomType,
    },
    resolvedCommit: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "resolved_commit",
    },
    syncStartedAt: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "sync_started_at",
    },
    lastSyncedAt: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "last_synced_at",
    },
    lastError: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "last_error",
    },
    createdAt: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "created_at",
    },
    createdByUserId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "created_by_user_id",
    },
    createdByServiceAccountId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "created_by_service_account_id",
    },
    tenantId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "tenant_id",
    },
  },
  primaryKey: ["id"],
  serverName: "skill_git_sources",
} as const;
const skillsTable = {
  name: "skills",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    name: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    description: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    instructions: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    enabled: {
      type: "boolean",
      optional: true,
      customType: null as unknown as boolean,
    },
    fresh: {
      type: "boolean",
      optional: false,
      customType: null as unknown as boolean,
    },
    createdAt: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "created_at",
    },
    createdByUserId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "created_by_user_id",
    },
    createdByServiceAccountId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "created_by_service_account_id",
    },
    tenantId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "tenant_id",
    },
  },
  primaryKey: ["id"],
} as const;
const spaceBranchMembersTable = {
  name: "spaceBranchMembers",
  columns: {
    spaceBranchId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "space_branch_id",
    },
    workflowId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "workflow_id",
    },
    forkCommitId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "fork_commit_id",
    },
    workflowBranchId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "workflow_branch_id",
    },
    syncedCommitId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "synced_commit_id",
    },
    deletedAt: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "deleted_at",
    },
    tenantId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "tenant_id",
    },
  },
  primaryKey: ["spaceBranchId", "workflowId"],
  serverName: "space_branch_members",
} as const;
const spaceBranchesTable = {
  name: "spaceBranches",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    spaceId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "space_id",
    },
    name: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    createdAt: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "created_at",
    },
    createdByUserId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "created_by_user_id",
    },
    createdByServiceAccountId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "created_by_service_account_id",
    },
    tenantId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "tenant_id",
    },
  },
  primaryKey: ["id"],
  serverName: "space_branches",
} as const;
const spaceGitPullRequestsTable = {
  name: "spaceGitPullRequests",
  columns: {
    spaceId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "space_id",
    },
    provider: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    prNumber: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "pr_number",
    },
    gitBranchName: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "git_branch_name",
    },
    title: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    url: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    state: {
      type: "string",
      optional: true,
      customType: null as unknown as "open" | "draft" | "merged" | "closed",
    },
    updatedAt: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "updated_at",
    },
    commentId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "comment_id",
    },
    tenantId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "tenant_id",
    },
  },
  primaryKey: ["prNumber", "spaceId"],
  serverName: "space_git_pull_requests",
} as const;
const spaceGitRemotesTable = {
  name: "spaceGitRemotes",
  columns: {
    spaceId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "space_id",
    },
    remoteUrl: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "remote_url",
    },
    directory: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    connectedAppId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "connected_app_id",
    },
    lastError: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "last_error",
    },
    lastSyncedAt: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "last_synced_at",
    },
    syncStartedAt: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "sync_started_at",
    },
    syncRequestedAt: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "sync_requested_at",
    },
    webhookReceivedAt: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "webhook_received_at",
    },
    webhookConfiguredAt: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "webhook_configured_at",
    },
    webhookError: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "webhook_error",
    },
    mainPushDeclinedAt: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "main_push_declined_at",
    },
    tenantId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "tenant_id",
    },
  },
  primaryKey: ["spaceId"],
  serverName: "space_git_remotes",
} as const;
const spaceStorageStatsTable = {
  name: "spaceStorageStats",
  columns: {
    spaceId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "space_id",
    },
    bytesUsed: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "bytes_used",
    },
    byteMinutes: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "byte_minutes",
    },
    updatedAt: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "updated_at",
    },
    tenantId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "tenant_id",
    },
  },
  primaryKey: ["spaceId"],
  serverName: "space_storage_stats",
} as const;
const spaceUserStatsTable = {
  name: "spaceUserStats",
  columns: {
    spaceId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "space_id",
    },
    userId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "user_id",
    },
    messageCount: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "message_count",
    },
    branchCount: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "branch_count",
    },
    tenantId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "tenant_id",
    },
  },
  primaryKey: ["spaceId", "userId"],
  serverName: "space_user_stats",
} as const;
const spaceVolumesTable = {
  name: "spaceVolumes",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    volumeId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "volume_id",
    },
    spaceId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "space_id",
    },
    branchId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "branch_id",
    },
    name: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    createdByUserId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "created_by_user_id",
    },
    createdByServiceAccountId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "created_by_service_account_id",
    },
    createdAt: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "created_at",
    },
    tenantId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "tenant_id",
    },
  },
  primaryKey: ["id"],
  serverName: "space_volumes",
} as const;
const spacesTable = {
  name: "spaces",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    name: {
      type: "string",
      optional: false,
      customType: null as unknown as SpacesNameCustomType,
    },
    slug: {
      type: "string",
      optional: false,
      customType: null as unknown as SpacesSlugCustomType,
    },
    mode: {
      type: "string",
      optional: false,
      customType: null as unknown as "public" | "private" | "personal",
    },
    createdAt: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "created_at",
    },
    updatedAt: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "updated_at",
    },
    defaultJoinBuiltinRoleId: {
      type: "string",
      optional: true,
      customType: null as unknown as
        | "tenant_admin"
        | "space_manager"
        | "space_editor"
        | "space_viewer"
        | "connected_app_editor"
        | "connected_app_sharer"
        | "connected_app_user"
        | "connected_app_viewer"
        | "skill_manager"
        | "skill_user"
        | "network_manager"
        | "network_user"
        | "network_viewer"
        | "user_group_manager"
        | "user_group_member"
        | "service_account_manager"
        | "service_account_user"
        | "service_account_viewer"
        | "app_creator"
        | "skill_creator"
        | "space_creator"
        | "network_creator"
        | "user_group_creator"
        | "service_account_creator"
        | "connector_sharer"
        | "oidc_provider_manager"
        | "space_manager_all",
      serverName: "default_join_builtin_role_id",
    },
    defaultJoinCustomRoleId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "default_join_custom_role_id",
    },
    blockSelfApproval: {
      type: "boolean",
      optional: true,
      customType: null as unknown as boolean,
      serverName: "block_self_approval",
    },
    tenantId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "tenant_id",
    },
  },
  primaryKey: ["id"],
} as const;
const ssoProviderTable = {
  name: "ssoProvider",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    issuer: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    domain: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    oidcConfigGeneration: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "oidc_config_generation",
    },
    oidcConfigWrittenGeneration: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "oidc_config_written_generation",
    },
    protocol: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    userId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "user_id",
    },
    providerId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "provider_id",
    },
    organizationId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "organization_id",
    },
    domainVerified: {
      type: "boolean",
      optional: true,
      customType: null as unknown as boolean,
      serverName: "domain_verified",
    },
    jitUserProvisioning: {
      type: "boolean",
      optional: true,
      customType: null as unknown as boolean,
      serverName: "jit_user_provisioning",
    },
    groupMappings: {
      type: "json",
      optional: true,
      customType: null as unknown as ReadonlyJSONValue,
      serverName: "group_mappings",
    },
    groupClaimName: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "group_claim_name",
    },
    syncMode: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "sync_mode",
    },
    scimTokenExpiresAt: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "scim_token_expires_at",
    },
    createdAt: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "created_at",
    },
    updatedAt: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "updated_at",
    },
    oauthTrustUpdatedAt: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "oauth_trust_updated_at",
    },
    tenantId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "tenant_id",
    },
  },
  primaryKey: ["id"],
  serverName: "sso_provider",
} as const;
const stepActivityTable = {
  name: "stepActivity",
  columns: {
    workflowId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "workflow_id",
    },
    branchId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "branch_id",
    },
    stepDir: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "step_dir",
    },
    latestExecutionId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "latest_execution_id",
    },
    latestStatus: {
      type: "string",
      optional: true,
      customType: null as unknown as "error" | "pending" | "success",
      serverName: "latest_status",
    },
    latestKind: {
      type: "string",
      optional: true,
      customType: null as unknown as
        | "build"
        | "run"
        | "image_build"
        | "image_run",
      serverName: "latest_kind",
    },
    latestCreatedAt: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "latest_created_at",
    },
    latestCompletedAt: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "latest_completed_at",
    },
    latestRenderableExecutionId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "latest_renderable_execution_id",
    },
    latestDuration: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "latest_duration",
    },
    executionCount: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "execution_count",
    },
    errorExecutionCount: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "error_execution_count",
    },
    completedExecutionCount: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "completed_execution_count",
    },
    completedErrorExecutionCount: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "completed_error_execution_count",
    },
    updatedAt: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "updated_at",
    },
    tenantId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "tenant_id",
    },
  },
  primaryKey: ["branchId", "stepDir", "workflowId"],
  serverName: "step_activity",
} as const;
const stepTestSpecsTable = {
  name: "stepTestSpecs",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    executionId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "execution_id",
    },
    name: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    status: {
      type: "string",
      optional: false,
      customType: null as unknown as "passed" | "failed" | "skipped",
    },
    message: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
    },
    ordinal: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
    },
    inputOutputHash: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "input_output_hash",
    },
    tenantId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "tenant_id",
    },
  },
  primaryKey: ["id"],
  serverName: "step_test_specs",
} as const;
const systemMessagesTable = {
  name: "systemMessages",
  columns: {
    entryId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "entry_id",
    },
    text: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    tenantId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "tenant_id",
    },
  },
  primaryKey: ["entryId"],
  serverName: "system_messages",
} as const;
const tenantCustomDomainsTable = {
  name: "tenantCustomDomains",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    domain: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    createdAt: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "created_at",
    },
    updatedAt: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "updated_at",
    },
    tenantId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "tenant_id",
    },
  },
  primaryKey: ["id"],
  serverName: "tenant_custom_domains",
} as const;
const tenantKeysTable = {
  name: "tenantKeys",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    domain: {
      type: "string",
      optional: false,
      customType: null as unknown as "credentials",
    },
    fingerprint: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    publicKey: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "public_key",
    },
    createdAt: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "created_at",
    },
    retiredAt: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "retired_at",
    },
    tenantId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "tenant_id",
    },
  },
  primaryKey: ["id"],
  serverName: "tenant_keys",
} as const;
const tenantsTable = {
  name: "tenants",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    name: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    companyName: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "company_name",
    },
    publicDomain: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "public_domain",
    },
    origin: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    publicOrigin: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "public_origin",
    },
    managedAiProviderDisabledAt: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "managed_ai_provider_disabled_at",
    },
    publicRouteAuthDisabled: {
      type: "boolean",
      optional: true,
      customType: null as unknown as boolean,
      serverName: "public_route_auth_disabled",
    },
    publicWebpageAuthDisabled: {
      type: "boolean",
      optional: true,
      customType: null as unknown as boolean,
      serverName: "public_webpage_auth_disabled",
    },
    externalIdWebpageAuthDisabled: {
      type: "boolean",
      optional: true,
      customType: null as unknown as boolean,
      serverName: "external_id_webpage_auth_disabled",
    },
    publicNonWebpageAuthDisabled: {
      type: "boolean",
      optional: true,
      customType: null as unknown as boolean,
      serverName: "public_non_webpage_auth_disabled",
    },
    active: {
      type: "boolean",
      optional: true,
      customType: null as unknown as boolean,
    },
    isExploreSignup: {
      type: "boolean",
      optional: true,
      customType: null as unknown as boolean,
      serverName: "is_explore_signup",
    },
    createdAt: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "created_at",
    },
    updatedAt: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "updated_at",
    },
  },
  primaryKey: ["id"],
} as const;
const toolCallsTable = {
  name: "toolCalls",
  columns: {
    entryId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "entry_id",
    },
    toolName: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "tool_name",
    },
    anthropicId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "anthropic_id",
    },
    input: {
      type: "json",
      optional: false,
      customType: null as unknown as ReadonlyJSONValue,
    },
    output: {
      type: "json",
      optional: true,
      customType: null as unknown as ReadonlyJSONValue,
    },
    outputBlobId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "output_blob_id",
    },
    isError: {
      type: "boolean",
      optional: true,
      customType: null as unknown as boolean,
      serverName: "is_error",
    },
    completedAt: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "completed_at",
    },
    tenantId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "tenant_id",
    },
  },
  primaryKey: ["entryId"],
  serverName: "tool_calls",
} as const;
const userTable = {
  name: "user",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    name: {
      type: "string",
      optional: false,
      customType: null as unknown as UserNameCustomType,
    },
    email: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    emailVerified: {
      type: "boolean",
      optional: true,
      customType: null as unknown as boolean,
      serverName: "email_verified",
    },
    image: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
    },
    customAvatarKey: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "custom_avatar_key",
    },
    hasCompletedPostSignupForm: {
      type: "boolean",
      optional: true,
      customType: null as unknown as boolean,
      serverName: "has_completed_post_signup_form",
    },
    deactivated: {
      type: "boolean",
      optional: true,
      customType: null as unknown as boolean,
    },
    invitedAt: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "invited_at",
    },
    createdAt: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "created_at",
    },
    updatedAt: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "updated_at",
    },
    lastActiveAt: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "last_active_at",
    },
    tenantId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "tenant_id",
    },
  },
  primaryKey: ["id"],
} as const;
const userActionsTable = {
  name: "userActions",
  columns: {
    entryId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "entry_id",
    },
    userId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "user_id",
    },
    actionType: {
      type: "string",
      optional: false,
      customType: null as unknown as
        | "pushDraftToLive"
        | "updateStepColor"
        | "updateStepTimeout"
        | "associateStepWithConnectedApp"
        | "dissociateStepFromConnectedApp"
        | "deleteStickyNote"
        | "reorderStickyNotes"
        | "pinStepTest"
        | "unpinStepTest",
      serverName: "action_type",
    },
    metadata: {
      type: "json",
      optional: false,
      customType: null as unknown as
        | { draftName: string }
        | { stepDir: string; color: string }
        | { stepDir: string; timeout: number | null }
        | { stepDir: string; connectedAppId: string; connectedAppName: string }
        | { title: string }
        | { count: number }
        | { stepDir: string; name: string },
    },
    tenantId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "tenant_id",
    },
  },
  primaryKey: ["entryId"],
  serverName: "user_actions",
} as const;
const userBranchPresenceTable = {
  name: "userBranchPresence",
  columns: {
    userId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "user_id",
    },
    workflowId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "workflow_id",
    },
    branchId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "branch_id",
    },
    stepDir: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "step_dir",
    },
    lastSeenAt: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "last_seen_at",
    },
    tenantId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "tenant_id",
    },
  },
  primaryKey: ["userId"],
  serverName: "user_branch_presence",
} as const;
const userGroupsTable = {
  name: "userGroups",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    name: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    createdAt: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "created_at",
    },
    updatedAt: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "updated_at",
    },
    tenantId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "tenant_id",
    },
  },
  primaryKey: ["id"],
  serverName: "user_groups",
} as const;
const userMessagesTable = {
  name: "userMessages",
  columns: {
    entryId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "entry_id",
    },
    userId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "user_id",
    },
    serviceAccountId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "service_account_id",
    },
    text: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    isDictated: {
      type: "boolean",
      optional: true,
      customType: null as unknown as boolean,
      serverName: "is_dictated",
    },
    planMode: {
      type: "boolean",
      optional: true,
      customType: null as unknown as boolean,
      serverName: "plan_mode",
    },
    effort: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
    },
    actionKind: {
      type: "string",
      optional: true,
      customType: null as unknown as
        | "error"
        | "readme"
        | "autotune"
        | "autofix"
        | "connector"
        | "investigate_step_test"
        | "step_test_fixture_setup",
      serverName: "action_kind",
    },
    tenantId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "tenant_id",
    },
  },
  primaryKey: ["entryId"],
  serverName: "user_messages",
} as const;
const userPreferencesTable = {
  name: "userPreferences",
  columns: {
    userId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "user_id",
    },
    spaceSortOrder: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "space_sort_order",
    },
    defaultHome: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "default_home",
    },
    soundClicks: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "sound_clicks",
    },
    soundChat: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "sound_chat",
    },
    soundWorkflow: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "sound_workflow",
    },
    theme: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
    },
    defaultSpace: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "default_space",
    },
    showCode: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "show_code",
    },
    browserNotifications: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "browser_notifications",
    },
    planModeDefault: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "plan_mode_default",
    },
    planModeChatDefault: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "plan_mode_chat_default",
    },
    planModeWorkflowDefault: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "plan_mode_workflow_default",
    },
    planModeBranchDefault: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "plan_mode_branch_default",
    },
    showFeatureFlagsNav: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "show_feature_flags_nav",
    },
    workflowTabOrder: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "workflow_tab_order",
    },
    follow3bByDefault: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "follow_3b_by_default",
    },
    suggestFollow3b: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "suggest_follow_3b",
    },
    aiProviderId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "ai_provider_id",
    },
    chatModel: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "chat_model",
    },
    followUpBehavior: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "follow_up_behavior",
    },
    navConfig: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "nav_config",
    },
    tenantId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "tenant_id",
    },
  },
  primaryKey: ["userId"],
  serverName: "user_preferences",
} as const;
const workflowBranchesTable = {
  name: "workflowBranches",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    workflowId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "workflow_id",
    },
    userId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "user_id",
    },
    serviceAccountId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "service_account_id",
    },
    name: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    headCommitId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "head_commit_id",
    },
    createdAt: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "created_at",
    },
    lastChatEntryAt: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "last_chat_entry_at",
    },
    lastRunAt: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "last_run_at",
    },
    respondingAt: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "responding_at",
    },
    forkCommitId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "fork_commit_id",
    },
    designId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "design_id",
    },
    parentChatSummary: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "parent_chat_summary",
    },
    awaitingAction: {
      type: "boolean",
      optional: true,
      customType: null as unknown as boolean,
      serverName: "awaiting_action",
    },
    lastChatEntryType: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "last_chat_entry_type",
    },
    tenantId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "tenant_id",
    },
  },
  primaryKey: ["id"],
  serverName: "workflow_branches",
} as const;
const workflowCommitsTable = {
  name: "workflowCommits",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    branchId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "branch_id",
    },
    parentCommitId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "parent_commit_id",
    },
    chatId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "chat_id",
    },
    message: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
    },
    createdAt: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "created_at",
    },
    createdByUserId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "created_by_user_id",
    },
    createdByServiceAccountId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "created_by_service_account_id",
    },
    tenantId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "tenant_id",
    },
  },
  primaryKey: ["id"],
  serverName: "workflow_commits",
} as const;
const workflowConnectedAppsTable = {
  name: "workflowConnectedApps",
  columns: {
    workflowId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "workflow_id",
    },
    slug: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    connectedAppId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "connected_app_id",
    },
    tenantId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "tenant_id",
    },
  },
  primaryKey: ["slug", "workflowId"],
  serverName: "workflow_connected_apps",
} as const;
const workflowFavoritesTable = {
  name: "workflowFavorites",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    userId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "user_id",
    },
    workflowId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "workflow_id",
    },
    createdAt: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "created_at",
    },
    tenantId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "tenant_id",
    },
  },
  primaryKey: ["id"],
  serverName: "workflow_favorites",
} as const;
const workflowRunDailyStatsTable = {
  name: "workflowRunDailyStats",
  columns: {
    workflowId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "workflow_id",
    },
    day: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
    },
    spaceId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "space_id",
    },
    runCount: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "run_count",
    },
    errorRunCount: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "error_run_count",
    },
    lastRunAt: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "last_run_at",
    },
    tenantId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "tenant_id",
    },
  },
  primaryKey: ["day", "workflowId"],
  serverName: "workflow_run_daily_stats",
} as const;
const workflowRunsTable = {
  name: "workflowRuns",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    workflowId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "workflow_id",
    },
    commitId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "commit_id",
    },
    branchId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "branch_id",
    },
    createdAt: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "created_at",
    },
    expiresAt: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "expires_at",
    },
    ephemeral: {
      type: "boolean",
      optional: true,
      customType: null as unknown as boolean,
    },
    interactive: {
      type: "boolean",
      optional: true,
      customType: null as unknown as boolean,
    },
    runStatus: {
      type: "string",
      optional: true,
      customType: null as unknown as "error" | "success" | "running",
      serverName: "run_status",
    },
    hasFailed: {
      type: "boolean",
      optional: true,
      customType: null as unknown as boolean,
      serverName: "has_failed",
    },
    tenantId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "tenant_id",
    },
  },
  primaryKey: ["id"],
  serverName: "workflow_runs",
} as const;
const workflowViewsTable = {
  name: "workflowViews",
  columns: {
    workflowId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "workflow_id",
    },
    userId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "user_id",
    },
    lastSeenAt: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "last_seen_at",
    },
    tenantId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "tenant_id",
    },
  },
  primaryKey: ["userId", "workflowId"],
  serverName: "workflow_views",
} as const;
const workflowsTable = {
  name: "workflows",
  columns: {
    id: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    spaceId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "space_id",
    },
    name: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
    },
    needsName: {
      type: "boolean",
      optional: true,
      customType: null as unknown as boolean,
      serverName: "needs_name",
    },
    badgeSeed: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "badge_seed",
    },
    createdAt: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "created_at",
    },
    updatedAt: {
      type: "number",
      optional: false,
      customType: null as unknown as number,
      serverName: "updated_at",
    },
    createdByUserId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "created_by_user_id",
    },
    createdByServiceAccountId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "created_by_service_account_id",
    },
    autofixEnabled: {
      type: "boolean",
      optional: true,
      customType: null as unknown as boolean,
      serverName: "autofix_enabled",
    },
    autofixBranchId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "autofix_branch_id",
    },
    autoImproveEnabled: {
      type: "boolean",
      optional: true,
      customType: null as unknown as boolean,
      serverName: "auto_improve_enabled",
    },
    autoImproveBranchId: {
      type: "string",
      optional: true,
      customType: null as unknown as string,
      serverName: "auto_improve_branch_id",
    },
    deletedAt: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "deleted_at",
    },
    pausedAt: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "paused_at",
    },
    estimatedMinutesSaved: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "estimated_minutes_saved",
    },
    estimatedBuildMinutesSaved: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "estimated_build_minutes_saved",
    },
    estimatedMonitorMinutesSaved: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "estimated_monitor_minutes_saved",
    },
    timeSavedSource: {
      type: "string",
      optional: true,
      customType: null as unknown as "llm" | "manual",
      serverName: "time_saved_source",
    },
    timeSavedBuildSource: {
      type: "string",
      optional: true,
      customType: null as unknown as "llm" | "manual",
      serverName: "time_saved_build_source",
    },
    timeSavedMonitorSource: {
      type: "string",
      optional: true,
      customType: null as unknown as "llm" | "manual",
      serverName: "time_saved_monitor_source",
    },
    timeSavedUpdatedAt: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "time_saved_updated_at",
    },
    retentionSeconds: {
      type: "number",
      optional: true,
      customType: null as unknown as number,
      serverName: "retention_seconds",
    },
    tenantId: {
      type: "string",
      optional: false,
      customType: null as unknown as string,
      serverName: "tenant_id",
    },
  },
  primaryKey: ["id"],
} as const;
const userRelationships = {
  roleGrantsAsPrincipal: [
    {
      sourceField: ["id", "tenantId"],
      destField: ["userId", "tenantId"],
      destSchema: "roleGrants",
      cardinality: "many",
    },
  ],
  tenantRoleGrantsAsScope: [
    {
      sourceField: ["tenantId", "tenantId"],
      destField: ["scopeId", "tenantId"],
      destSchema: "roleGrants",
      cardinality: "many",
    },
  ],
} as const;
const apikeyRelationships = {
  user: [
    {
      sourceField: ["referenceId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "user",
      cardinality: "one",
    },
  ],
  space: [
    {
      sourceField: ["spaceId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "spaces",
      cardinality: "one",
    },
  ],
  serviceAccount: [
    {
      sourceField: ["serviceAccountId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "serviceAccounts",
      cardinality: "one",
    },
  ],
  tenantRoleGrantsAsScope: [
    {
      sourceField: ["tenantId", "tenantId"],
      destField: ["scopeId", "tenantId"],
      destSchema: "roleGrants",
      cardinality: "many",
    },
  ],
} as const;
const ssoProviderRelationships = {
  tenantRoleGrantsAsScope: [
    {
      sourceField: ["tenantId", "tenantId"],
      destField: ["scopeId", "tenantId"],
      destSchema: "roleGrants",
      cardinality: "many",
    },
  ],
} as const;
const spacesRelationships = {
  workflows: [
    {
      sourceField: ["id", "tenantId"],
      destField: ["spaceId", "tenantId"],
      destSchema: "workflows",
      cardinality: "many",
    },
  ],
  executionStats: [
    {
      sourceField: ["id", "tenantId"],
      destField: ["spaceId", "tenantId"],
      destSchema: "executionStats",
      cardinality: "many",
    },
  ],
  networkUsageBuckets: [
    {
      sourceField: ["id", "tenantId"],
      destField: ["spaceId", "tenantId"],
      destSchema: "networkUsageBuckets",
      cardinality: "many",
    },
  ],
  roleGrantsAsScope: [
    {
      sourceField: ["id", "tenantId"],
      destField: ["scopeId", "tenantId"],
      destSchema: "roleGrants",
      cardinality: "many",
    },
  ],
  tenantRoleGrantsAsScope: [
    {
      sourceField: ["tenantId", "tenantId"],
      destField: ["scopeId", "tenantId"],
      destSchema: "roleGrants",
      cardinality: "many",
    },
  ],
} as const;
const spaceVolumesRelationships = {
  space: [
    {
      sourceField: ["spaceId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "spaces",
      cardinality: "one",
    },
  ],
  branch: [
    {
      sourceField: ["branchId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "workflowBranches",
      cardinality: "one",
    },
  ],
  createdBy: [
    {
      sourceField: ["createdByUserId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "user",
      cardinality: "one",
    },
  ],
} as const;
const spaceGitRemotesRelationships = {
  space: [
    {
      sourceField: ["spaceId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "spaces",
      cardinality: "one",
    },
  ],
  appUsage: [
    {
      sourceField: ["spaceId", "tenantId"],
      destField: ["refId", "tenantId"],
      destSchema: "connectedAppUsages",
      cardinality: "one",
    },
  ],
} as const;
const gitBranchCursorsRelationships = {
  space: [
    {
      sourceField: ["spaceId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "spaces",
      cardinality: "one",
    },
  ],
} as const;
const spaceGitPullRequestsRelationships = {
  space: [
    {
      sourceField: ["spaceId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "spaces",
      cardinality: "one",
    },
  ],
  spaceBranch: [
    {
      sourceField: ["spaceId", "gitBranchName", "tenantId"],
      destField: ["spaceId", "name", "tenantId"],
      destSchema: "spaceBranches",
      cardinality: "one",
    },
  ],
} as const;
const spaceBranchesRelationships = {
  space: [
    {
      sourceField: ["spaceId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "spaces",
      cardinality: "one",
    },
  ],
  createdBy: [
    {
      sourceField: ["createdByUserId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "user",
      cardinality: "one",
    },
  ],
  members: [
    {
      sourceField: ["id", "tenantId"],
      destField: ["spaceBranchId", "tenantId"],
      destSchema: "spaceBranchMembers",
      cardinality: "many",
    },
  ],
} as const;
const spaceBranchMembersRelationships = {
  spaceBranch: [
    {
      sourceField: ["spaceBranchId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "spaceBranches",
      cardinality: "one",
    },
  ],
  workflow: [
    {
      sourceField: ["workflowId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "workflows",
      cardinality: "one",
    },
  ],
} as const;
const userBranchPresenceRelationships = {
  user: [
    {
      sourceField: ["userId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "user",
      cardinality: "one",
    },
  ],
  workflow: [
    {
      sourceField: ["workflowId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "workflows",
      cardinality: "one",
    },
  ],
  branch: [
    {
      sourceField: ["branchId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "workflowBranches",
      cardinality: "one",
    },
  ],
} as const;
const duplicateWorkflowPairsRelationships = {
  workflowA: [
    {
      sourceField: ["workflowAId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "workflows",
      cardinality: "one",
    },
  ],
  workflowB: [
    {
      sourceField: ["workflowBId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "workflows",
      cardinality: "one",
    },
  ],
} as const;
const duplicateWorkflowReviewsRelationships = {
  workflowA: [
    {
      sourceField: ["workflowAId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "workflows",
      cardinality: "one",
    },
  ],
  workflowB: [
    {
      sourceField: ["workflowBId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "workflows",
      cardinality: "one",
    },
  ],
} as const;
const workflowFavoritesRelationships = {
  workflow: [
    {
      sourceField: ["workflowId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "workflows",
      cardinality: "one",
    },
  ],
  user: [
    {
      sourceField: ["userId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "user",
      cardinality: "one",
    },
  ],
} as const;
const routeFavoritesRelationships = {
  workflow: [
    {
      sourceField: ["workflowId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "workflows",
      cardinality: "one",
    },
  ],
  user: [
    {
      sourceField: ["userId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "user",
      cardinality: "one",
    },
  ],
} as const;
const workflowViewsRelationships = {
  workflow: [
    {
      sourceField: ["workflowId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "workflows",
      cardinality: "one",
    },
  ],
  user: [
    {
      sourceField: ["userId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "user",
      cardinality: "one",
    },
  ],
} as const;
const routeViewsRelationships = {
  workflow: [
    {
      sourceField: ["workflowId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "workflows",
      cardinality: "one",
    },
  ],
  user: [
    {
      sourceField: ["userId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "user",
      cardinality: "one",
    },
  ],
} as const;
const workflowsRelationships = {
  space: [
    {
      sourceField: ["spaceId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "spaces",
      cardinality: "one",
    },
  ],
  createdBy: [
    {
      sourceField: ["createdByUserId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "user",
      cardinality: "one",
    },
  ],
  branches: [
    {
      sourceField: ["id", "tenantId"],
      destField: ["workflowId", "tenantId"],
      destSchema: "workflowBranches",
      cardinality: "many",
    },
  ],
  workflowRuns: [
    {
      sourceField: ["id", "tenantId"],
      destField: ["workflowId", "tenantId"],
      destSchema: "workflowRuns",
      cardinality: "many",
    },
  ],
  runDailyStats: [
    {
      sourceField: ["id", "tenantId"],
      destField: ["workflowId", "tenantId"],
      destSchema: "workflowRunDailyStats",
      cardinality: "many",
    },
  ],
  executionStats: [
    {
      sourceField: ["id", "tenantId"],
      destField: ["workflowId", "tenantId"],
      destSchema: "executionStats",
      cardinality: "many",
    },
  ],
  networkUsageBuckets: [
    {
      sourceField: ["id", "tenantId"],
      destField: ["workflowId", "tenantId"],
      destSchema: "networkUsageBuckets",
      cardinality: "many",
    },
  ],
  favorites: [
    {
      sourceField: ["id", "tenantId"],
      destField: ["workflowId", "tenantId"],
      destSchema: "workflowFavorites",
      cardinality: "many",
    },
  ],
  stepActivity: [
    {
      sourceField: ["id", "tenantId"],
      destField: ["workflowId", "tenantId"],
      destSchema: "stepActivity",
      cardinality: "many",
    },
  ],
  contributors: [
    {
      sourceField: ["id", "tenantId"],
      destField: ["workflowId", "tenantId"],
      destSchema: "branchContributors",
      cardinality: "many",
    },
  ],
} as const;
const workflowBranchesRelationships = {
  workflow: [
    {
      sourceField: ["workflowId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "workflows",
      cardinality: "one",
    },
  ],
  user: [
    {
      sourceField: ["userId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "user",
      cardinality: "one",
    },
  ],
  serviceAccount: [
    {
      sourceField: ["serviceAccountId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "serviceAccounts",
      cardinality: "one",
    },
  ],
  headCommit: [
    {
      sourceField: ["headCommitId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "workflowCommits",
      cardinality: "one",
    },
  ],
  headCommitChat: [
    {
      sourceField: ["headCommitId", "tenantId"],
      destField: ["commitId", "tenantId"],
      destSchema: "chats",
      cardinality: "one",
    },
  ],
  design: [
    {
      sourceField: ["designId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "designs",
      cardinality: "one",
    },
  ],
  commits: [
    {
      sourceField: ["id", "tenantId"],
      destField: ["branchId", "tenantId"],
      destSchema: "workflowCommits",
      cardinality: "many",
    },
  ],
  contributors: [
    {
      sourceField: ["id", "tenantId"],
      destField: ["branchId", "tenantId"],
      destSchema: "branchContributors",
      cardinality: "many",
    },
  ],
  workflowRuns: [
    {
      sourceField: ["id", "tenantId"],
      destField: ["branchId", "tenantId"],
      destSchema: "workflowRuns",
      cardinality: "many",
    },
  ],
  spaceBranchMembers: [
    {
      sourceField: ["id", "tenantId"],
      destField: ["workflowBranchId", "tenantId"],
      destSchema: "spaceBranchMembers",
      cardinality: "many",
    },
  ],
} as const;
const branchContributorsRelationships = {
  branch: [
    {
      sourceField: ["branchId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "workflowBranches",
      cardinality: "one",
    },
  ],
  workflow: [
    {
      sourceField: ["workflowId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "workflows",
      cardinality: "one",
    },
  ],
  user: [
    {
      sourceField: ["userId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "user",
      cardinality: "one",
    },
  ],
} as const;
const branchModelPreferencesRelationships = {
  branch: [
    {
      sourceField: ["branchId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "workflowBranches",
      cardinality: "one",
    },
  ],
  user: [
    {
      sourceField: ["userId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "user",
      cardinality: "one",
    },
  ],
} as const;
const workflowCommitsRelationships = {
  branch: [
    {
      sourceField: ["branchId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "workflowBranches",
      cardinality: "one",
    },
  ],
  createdBy: [
    {
      sourceField: ["createdByUserId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "user",
      cardinality: "one",
    },
  ],
  chats: [
    {
      sourceField: ["id", "tenantId"],
      destField: ["commitId", "tenantId"],
      destSchema: "chats",
      cardinality: "many",
    },
  ],
  files: [
    {
      sourceField: ["id", "tenantId"],
      destField: ["commitId", "tenantId"],
      destSchema: "commitFiles",
      cardinality: "many",
    },
  ],
  routes: [
    {
      sourceField: ["id", "tenantId"],
      destField: ["commitId", "tenantId"],
      destSchema: "commitRoutes",
      cardinality: "many",
    },
  ],
  dependencies: [
    {
      sourceField: ["id", "tenantId"],
      destField: ["commitId", "tenantId"],
      destSchema: "commitDependencies",
      cardinality: "many",
    },
  ],
  schedules: [
    {
      sourceField: ["id", "tenantId"],
      destField: ["commitId", "tenantId"],
      destSchema: "commitSchedules",
      cardinality: "many",
    },
  ],
  emailAddresses: [
    {
      sourceField: ["id", "tenantId"],
      destField: ["commitId", "tenantId"],
      destSchema: "commitEmailAddresses",
      cardinality: "many",
    },
  ],
  links: [
    {
      sourceField: ["id", "tenantId"],
      destField: ["commitId", "tenantId"],
      destSchema: "commitLinks",
      cardinality: "many",
    },
  ],
  appUsages: [
    {
      sourceField: ["id", "tenantId"],
      destField: ["refId", "tenantId"],
      destSchema: "connectedAppUsages",
      cardinality: "many",
    },
  ],
} as const;
const workflowRunsRelationships = {
  workflow: [
    {
      sourceField: ["workflowId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "workflows",
      cardinality: "one",
    },
  ],
  commit: [
    {
      sourceField: ["commitId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "workflowCommits",
      cardinality: "one",
    },
  ],
  branch: [
    {
      sourceField: ["branchId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "workflowBranches",
      cardinality: "one",
    },
  ],
} as const;
const oauthConnectionsRelationships = {
  connectedApps: [
    {
      sourceField: ["id", "tenantId"],
      destField: ["oauthConnectionId", "tenantId"],
      destSchema: "connectedApps",
      cardinality: "many",
    },
  ],
} as const;
const connectedAppsRelationships = {
  oauthConnection: [
    {
      sourceField: ["oauthConnectionId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "oauthConnections",
      cardinality: "one",
    },
  ],
  createdBy: [
    {
      sourceField: ["createdByUserId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "user",
      cardinality: "one",
    },
  ],
  usages: [
    {
      sourceField: ["id", "tenantId"],
      destField: ["connectedAppId", "tenantId"],
      destSchema: "connectedAppUsages",
      cardinality: "many",
    },
  ],
  roleGrantsAsScope: [
    {
      sourceField: ["id", "tenantId"],
      destField: ["scopeId", "tenantId"],
      destSchema: "roleGrants",
      cardinality: "many",
    },
  ],
  tenantRoleGrantsAsScope: [
    {
      sourceField: ["tenantId", "tenantId"],
      destField: ["scopeId", "tenantId"],
      destSchema: "roleGrants",
      cardinality: "many",
    },
  ],
} as const;
const skillsRelationships = {
  createdBy: [
    {
      sourceField: ["createdByUserId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "user",
      cardinality: "one",
    },
  ],
  roleGrantsAsScope: [
    {
      sourceField: ["id", "tenantId"],
      destField: ["scopeId", "tenantId"],
      destSchema: "roleGrants",
      cardinality: "many",
    },
  ],
  tenantRoleGrantsAsScope: [
    {
      sourceField: ["tenantId", "tenantId"],
      destField: ["scopeId", "tenantId"],
      destSchema: "roleGrants",
      cardinality: "many",
    },
  ],
  files: [
    {
      sourceField: ["id", "tenantId"],
      destField: ["skillId", "tenantId"],
      destSchema: "skillFiles",
      cardinality: "many",
    },
  ],
  gitInstallation: [
    {
      sourceField: ["id", "tenantId"],
      destField: ["skillId", "tenantId"],
      destSchema: "skillGitInstallations",
      cardinality: "one",
    },
  ],
} as const;
const skillFilesRelationships = {
  skill: [
    {
      sourceField: ["skillId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "skills",
      cardinality: "one",
    },
  ],
  blob: [
    {
      sourceField: ["blobHash", "tenantId"],
      destField: ["hash", "tenantId"],
      destSchema: "blobs",
      cardinality: "one",
    },
  ],
} as const;
const skillGitSourcesRelationships = {
  createdBy: [
    {
      sourceField: ["createdByUserId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "user",
      cardinality: "one",
    },
  ],
  connectedApp: [
    {
      sourceField: ["connectedAppId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "connectedApps",
      cardinality: "one",
    },
  ],
  appUsage: [
    {
      sourceField: ["id", "tenantId"],
      destField: ["refId", "tenantId"],
      destSchema: "connectedAppUsages",
      cardinality: "one",
    },
  ],
  installations: [
    {
      sourceField: ["id", "tenantId"],
      destField: ["sourceId", "tenantId"],
      destSchema: "skillGitInstallations",
      cardinality: "many",
    },
  ],
} as const;
const skillGitInstallationsRelationships = {
  skill: [
    {
      sourceField: ["skillId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "skills",
      cardinality: "one",
    },
  ],
  source: [
    {
      sourceField: ["sourceId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "skillGitSources",
      cardinality: "one",
    },
  ],
} as const;
const designsRelationships = {
  createdBy: [
    {
      sourceField: ["createdByUserId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "user",
      cardinality: "one",
    },
  ],
  branches: [
    {
      sourceField: ["id", "tenantId"],
      destField: ["designId", "tenantId"],
      destSchema: "workflowBranches",
      cardinality: "many",
    },
  ],
} as const;
const chatsRelationships = {
  commit: [
    {
      sourceField: ["commitId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "workflowCommits",
      cardinality: "one",
    },
  ],
  entries: [
    {
      sourceField: ["id", "tenantId"],
      destField: ["chatId", "tenantId"],
      destSchema: "chatEntries",
      cardinality: "many",
    },
  ],
  personalChat: [
    {
      sourceField: ["id", "tenantId"],
      destField: ["chatId", "tenantId"],
      destSchema: "personalChats",
      cardinality: "one",
    },
  ],
} as const;
const personalChatsRelationships = {
  chat: [
    {
      sourceField: ["chatId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "chats",
      cardinality: "one",
    },
  ],
  user: [
    {
      sourceField: ["userId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "user",
      cardinality: "one",
    },
  ],
  appUsages: [
    {
      sourceField: ["id", "tenantId"],
      destField: ["refId", "tenantId"],
      destSchema: "connectedAppUsages",
      cardinality: "many",
    },
  ],
} as const;
const chatEntriesRelationships = {
  chat: [
    {
      sourceField: ["chatId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "chats",
      cardinality: "one",
    },
  ],
  userMessage: [
    {
      sourceField: ["id", "tenantId"],
      destField: ["entryId", "tenantId"],
      destSchema: "userMessages",
      cardinality: "one",
    },
  ],
  assistantMessage: [
    {
      sourceField: ["id", "tenantId"],
      destField: ["entryId", "tenantId"],
      destSchema: "assistantMessages",
      cardinality: "one",
    },
  ],
  toolCall: [
    {
      sourceField: ["id", "tenantId"],
      destField: ["entryId", "tenantId"],
      destSchema: "toolCalls",
      cardinality: "one",
    },
  ],
  assistantReasoning: [
    {
      sourceField: ["id", "tenantId"],
      destField: ["entryId", "tenantId"],
      destSchema: "assistantReasonings",
      cardinality: "one",
    },
  ],
  compaction: [
    {
      sourceField: ["id", "tenantId"],
      destField: ["entryId", "tenantId"],
      destSchema: "compactions",
      cardinality: "one",
    },
  ],
  systemMessage: [
    {
      sourceField: ["id", "tenantId"],
      destField: ["entryId", "tenantId"],
      destSchema: "systemMessages",
      cardinality: "one",
    },
  ],
  userAction: [
    {
      sourceField: ["id", "tenantId"],
      destField: ["entryId", "tenantId"],
      destSchema: "userActions",
      cardinality: "one",
    },
  ],
  attachments: [
    {
      sourceField: ["id", "tenantId"],
      destField: ["entryId", "tenantId"],
      destSchema: "attachments",
      cardinality: "many",
    },
  ],
} as const;
const userMessagesRelationships = {
  user: [
    {
      sourceField: ["userId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "user",
      cardinality: "one",
    },
  ],
  serviceAccount: [
    {
      sourceField: ["serviceAccountId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "serviceAccounts",
      cardinality: "one",
    },
  ],
} as const;
const userActionsRelationships = {
  user: [
    {
      sourceField: ["userId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "user",
      cardinality: "one",
    },
  ],
} as const;
const commitFilesRelationships = {
  commit: [
    {
      sourceField: ["commitId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "workflowCommits",
      cardinality: "one",
    },
  ],
  blob: [
    {
      sourceField: ["blobHash", "tenantId"],
      destField: ["hash", "tenantId"],
      destSchema: "blobs",
      cardinality: "one",
    },
  ],
} as const;
const commitRoutesRelationships = {
  commit: [
    {
      sourceField: ["commitId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "workflowCommits",
      cardinality: "one",
    },
  ],
} as const;
const commitDependenciesRelationships = {
  commit: [
    {
      sourceField: ["commitId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "workflowCommits",
      cardinality: "one",
    },
  ],
} as const;
const commitSchedulesRelationships = {
  commit: [
    {
      sourceField: ["commitId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "workflowCommits",
      cardinality: "one",
    },
  ],
} as const;
const commitEmailAddressesRelationships = {
  commit: [
    {
      sourceField: ["commitId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "workflowCommits",
      cardinality: "one",
    },
  ],
} as const;
const commitLinksRelationships = {
  commit: [
    {
      sourceField: ["commitId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "workflowCommits",
      cardinality: "one",
    },
  ],
} as const;
const networksRelationships = {
  createdBy: [
    {
      sourceField: ["createdByUserId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "user",
      cardinality: "one",
    },
  ],
  roleGrantsAsScope: [
    {
      sourceField: ["id", "tenantId"],
      destField: ["scopeId", "tenantId"],
      destSchema: "roleGrants",
      cardinality: "many",
    },
  ],
  tenantRoleGrantsAsScope: [
    {
      sourceField: ["tenantId", "tenantId"],
      destField: ["scopeId", "tenantId"],
      destSchema: "roleGrants",
      cardinality: "many",
    },
  ],
  egressRoutes: [
    {
      sourceField: ["id", "tenantId"],
      destField: ["networkId", "tenantId"],
      destSchema: "egressRoutes",
      cardinality: "many",
    },
  ],
} as const;
const egressRoutesRelationships = {
  network: [
    {
      sourceField: ["networkId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "networks",
      cardinality: "one",
    },
  ],
} as const;
const egressRulesRelationships = {
  tenantRoleGrantsAsScope: [
    {
      sourceField: ["tenantId", "tenantId"],
      destField: ["scopeId", "tenantId"],
      destSchema: "roleGrants",
      cardinality: "many",
    },
  ],
} as const;
const connectionClaimsRelationships = {
  workflow: [
    {
      sourceField: ["workflowId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "workflows",
      cardinality: "one",
    },
  ],
} as const;
const grantRequestsRelationships = {
  scopeAsConnector: [
    {
      sourceField: ["scopeId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "connectedApps",
      cardinality: "one",
    },
  ],
  requestedByUser: [
    {
      sourceField: ["requestedByUserId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "user",
      cardinality: "one",
    },
  ],
  requestedGrants: [
    {
      sourceField: ["id", "tenantId"],
      destField: ["requestId", "tenantId"],
      destSchema: "grantRequestGrants",
      cardinality: "many",
    },
  ],
  tenantRoleGrantsAsScope: [
    {
      sourceField: ["tenantId", "tenantId"],
      destField: ["scopeId", "tenantId"],
      destSchema: "roleGrants",
      cardinality: "many",
    },
  ],
} as const;
const stepActivityRelationships = {
  workflow: [
    {
      sourceField: ["workflowId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "workflows",
      cardinality: "one",
    },
  ],
} as const;
const spaceUserStatsRelationships = {
  space: [
    {
      sourceField: ["spaceId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "spaces",
      cardinality: "one",
    },
  ],
  user: [
    {
      sourceField: ["userId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "user",
      cardinality: "one",
    },
  ],
} as const;
const spaceStorageStatsRelationships = {
  space: [
    {
      sourceField: ["spaceId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "spaces",
      cardinality: "one",
    },
  ],
} as const;
const workflowRunDailyStatsRelationships = {
  workflow: [
    {
      sourceField: ["workflowId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "workflows",
      cardinality: "one",
    },
  ],
} as const;
const executionStatsRelationships = {
  space: [
    {
      sourceField: ["spaceId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "spaces",
      cardinality: "one",
    },
  ],
  workflow: [
    {
      sourceField: ["workflowId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "workflows",
      cardinality: "one",
    },
  ],
  tenantRoleGrantsAsScope: [
    {
      sourceField: ["tenantId", "tenantId"],
      destField: ["scopeId", "tenantId"],
      destSchema: "roleGrants",
      cardinality: "many",
    },
  ],
} as const;
const networkUsageBucketsRelationships = {
  space: [
    {
      sourceField: ["spaceId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "spaces",
      cardinality: "one",
    },
  ],
  workflow: [
    {
      sourceField: ["workflowId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "workflows",
      cardinality: "one",
    },
  ],
  tenantRoleGrantsAsScope: [
    {
      sourceField: ["tenantId", "tenantId"],
      destField: ["scopeId", "tenantId"],
      destSchema: "roleGrants",
      cardinality: "many",
    },
  ],
} as const;
const featureFlagsRelationships = {
  createdBy: [
    {
      sourceField: ["createdByUserId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "user",
      cardinality: "one",
    },
  ],
} as const;
const auditLogsRelationships = {
  tenantRoleGrantsAsScope: [
    {
      sourceField: ["tenantId", "tenantId"],
      destField: ["scopeId", "tenantId"],
      destSchema: "roleGrants",
      cardinality: "many",
    },
  ],
} as const;
const auditLogDestinationsRelationships = {
  appUsage: [
    {
      sourceField: ["id", "tenantId"],
      destField: ["refId", "tenantId"],
      destSchema: "connectedAppUsages",
      cardinality: "one",
    },
  ],
  tenantRoleGrantsAsScope: [
    {
      sourceField: ["tenantId", "tenantId"],
      destField: ["scopeId", "tenantId"],
      destSchema: "roleGrants",
      cardinality: "many",
    },
  ],
} as const;
const connectedAppUsagesRelationships = {
  connectedApp: [
    {
      sourceField: ["connectedAppId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "connectedApps",
      cardinality: "one",
    },
  ],
  commit: [
    {
      sourceField: ["refId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "workflowCommits",
      cardinality: "one",
    },
  ],
  workflow: [
    {
      sourceField: ["refId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "workflows",
      cardinality: "one",
    },
  ],
  personalChat: [
    {
      sourceField: ["refId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "personalChats",
      cardinality: "one",
    },
  ],
  space: [
    {
      sourceField: ["refId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "spaces",
      cardinality: "one",
    },
  ],
  spaceGitRemote: [
    {
      sourceField: ["refId", "tenantId"],
      destField: ["spaceId", "tenantId"],
      destSchema: "spaceGitRemotes",
      cardinality: "one",
    },
  ],
  auditLogDestination: [
    {
      sourceField: ["refId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "auditLogDestinations",
      cardinality: "one",
    },
  ],
  aiProvider: [
    {
      sourceField: ["refId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "aiProviders",
      cardinality: "one",
    },
  ],
  branchesAtHead: [
    {
      sourceField: ["refId", "tenantId"],
      destField: ["headCommitId", "tenantId"],
      destSchema: "workflowBranches",
      cardinality: "many",
    },
  ],
} as const;
const aiProvidersRelationships = {
  appUsage: [
    {
      sourceField: ["id", "tenantId"],
      destField: ["refId", "tenantId"],
      destSchema: "connectedAppUsages",
      cardinality: "one",
    },
  ],
  tenantRoleGrantsAsScope: [
    {
      sourceField: ["tenantId", "tenantId"],
      destField: ["scopeId", "tenantId"],
      destSchema: "roleGrants",
      cardinality: "many",
    },
  ],
  modelPricing: [
    {
      sourceField: ["id", "tenantId"],
      destField: ["aiProviderId", "tenantId"],
      destSchema: "aiModelPricing",
      cardinality: "many",
    },
  ],
  budgets: [
    {
      sourceField: ["id", "tenantId"],
      destField: ["aiProviderId", "tenantId"],
      destSchema: "aiBudgets",
      cardinality: "many",
    },
  ],
} as const;
const aiUsageDailyRelationships = {
  workflow: [
    {
      sourceField: ["workflowId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "workflows",
      cardinality: "one",
    },
  ],
} as const;
const connectorUsageDimensionsRelationships = {
  connectedApp: [
    {
      sourceField: ["connectorId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "connectedApps",
      cardinality: "one",
    },
  ],
} as const;
const aiModelPricingRelationships = {
  aiProvider: [
    {
      sourceField: ["aiProviderId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "aiProviders",
      cardinality: "one",
    },
  ],
} as const;
const aiBudgetsRelationships = {
  aiProvider: [
    {
      sourceField: ["aiProviderId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "aiProviders",
      cardinality: "one",
    },
  ],
} as const;
const userGroupsRelationships = {
  roleGrantsAsPrincipal: [
    {
      sourceField: ["id", "tenantId"],
      destField: ["userGroupId", "tenantId"],
      destSchema: "roleGrants",
      cardinality: "many",
    },
  ],
  roleGrantsAsScope: [
    {
      sourceField: ["id", "tenantId"],
      destField: ["scopeId", "tenantId"],
      destSchema: "roleGrants",
      cardinality: "many",
    },
  ],
} as const;
const serviceAccountsRelationships = {
  apiKeys: [
    {
      sourceField: ["id", "tenantId"],
      destField: ["serviceAccountId", "tenantId"],
      destSchema: "apikey",
      cardinality: "many",
    },
  ],
  roleGrantsAsPrincipal: [
    {
      sourceField: ["id", "tenantId"],
      destField: ["serviceAccountId", "tenantId"],
      destSchema: "roleGrants",
      cardinality: "many",
    },
  ],
  roleGrantsAsScope: [
    {
      sourceField: ["id", "tenantId"],
      destField: ["scopeId", "tenantId"],
      destSchema: "roleGrants",
      cardinality: "many",
    },
  ],
  tenantRoleGrantsAsScope: [
    {
      sourceField: ["tenantId", "tenantId"],
      destField: ["scopeId", "tenantId"],
      destSchema: "roleGrants",
      cardinality: "many",
    },
  ],
  federations: [
    {
      sourceField: ["id", "tenantId"],
      destField: ["serviceAccountId", "tenantId"],
      destSchema: "serviceAccountFederations",
      cardinality: "many",
    },
  ],
} as const;
const serviceAccountFederationsRelationships = {
  serviceAccount: [
    {
      sourceField: ["serviceAccountId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "serviceAccounts",
      cardinality: "one",
    },
  ],
  provider: [
    {
      sourceField: ["providerId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "oidcProviders",
      cardinality: "one",
    },
  ],
  roleGrantsAsScope: [
    {
      sourceField: ["serviceAccountId", "tenantId"],
      destField: ["scopeId", "tenantId"],
      destSchema: "roleGrants",
      cardinality: "many",
    },
  ],
} as const;
const oidcProvidersRelationships = {
  federations: [
    {
      sourceField: ["id", "tenantId"],
      destField: ["providerId", "tenantId"],
      destSchema: "serviceAccountFederations",
      cardinality: "many",
    },
  ],
  tenantRoleGrantsAsScope: [
    {
      sourceField: ["tenantId", "tenantId"],
      destField: ["scopeId", "tenantId"],
      destSchema: "roleGrants",
      cardinality: "many",
    },
  ],
} as const;
const oauthClientRelationships = {
  tenantRoleGrantsAsScope: [
    {
      sourceField: ["tenantId", "tenantId"],
      destField: ["scopeId", "tenantId"],
      destSchema: "roleGrants",
      cardinality: "many",
    },
  ],
  serviceAccountAuthorizations: [
    {
      sourceField: ["id", "tenantId"],
      destField: ["clientId", "tenantId"],
      destSchema: "oauthClientServiceAccount",
      cardinality: "many",
    },
  ],
} as const;
const oauthClientServiceAccountRelationships = {
  serviceAccount: [
    {
      sourceField: ["serviceAccountId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "serviceAccounts",
      cardinality: "one",
    },
  ],
} as const;
const oauthGrantRelationships = {
  serviceAccount: [
    {
      sourceField: ["serviceAccountId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "serviceAccounts",
      cardinality: "one",
    },
  ],
  client: [
    {
      sourceField: ["clientId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "oauthClient",
      cardinality: "one",
    },
  ],
} as const;
const rolesRelationships = {
  rolePermissions: [
    {
      sourceField: ["id", "tenantId"],
      destField: ["roleId", "tenantId"],
      destSchema: "rolePermissions",
      cardinality: "many",
    },
  ],
  roleGrants: [
    {
      sourceField: ["id", "tenantId"],
      destField: ["customRoleId", "tenantId"],
      destSchema: "roleGrants",
      cardinality: "many",
    },
  ],
} as const;
const roleGrantsRelationships = {
  user: [
    {
      sourceField: ["userId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "user",
      cardinality: "one",
    },
  ],
  userGroup: [
    {
      sourceField: ["userGroupId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "userGroups",
      cardinality: "one",
    },
  ],
  serviceAccount: [
    {
      sourceField: ["serviceAccountId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "serviceAccounts",
      cardinality: "one",
    },
  ],
  customRole: [
    {
      sourceField: ["customRoleId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "roles",
      cardinality: "one",
    },
  ],
  groupMembershipGrants: [
    {
      sourceField: ["userGroupId", "tenantId"],
      destField: ["scopeId", "tenantId"],
      destSchema: "roleGrants",
      cardinality: "many",
    },
  ],
  scopeAsSpace: [
    {
      sourceField: ["scopeId", "tenantId"],
      destField: ["id", "tenantId"],
      destSchema: "spaces",
      cardinality: "one",
    },
  ],
} as const;
/**
 * The Zero schema object.
 * This type is auto-generated from your Drizzle schema definition.
 */
export const schema = {
  tables: {
    aiBudgets: aiBudgetsTable,
    aiModelPricing: aiModelPricingTable,
    aiProviders: aiProvidersTable,
    aiUsageDaily: aiUsageDailyTable,
    apikey: apikeyTable,
    assistantMessages: assistantMessagesTable,
    assistantReasonings: assistantReasoningsTable,
    attachments: attachmentsTable,
    auditLogDestinations: auditLogDestinationsTable,
    auditLogs: auditLogsTable,
    blobs: blobsTable,
    branchContributors: branchContributorsTable,
    branchModelPreferences: branchModelPreferencesTable,
    buildCaches: buildCachesTable,
    chatEntries: chatEntriesTable,
    chats: chatsTable,
    commitConnectedApps: commitConnectedAppsTable,
    commitDependencies: commitDependenciesTable,
    commitEmailAddresses: commitEmailAddressesTable,
    commitFiles: commitFilesTable,
    commitLinks: commitLinksTable,
    commitRoutes: commitRoutesTable,
    commitSchedules: commitSchedulesTable,
    commitStepLayers: commitStepLayersTable,
    compactions: compactionsTable,
    connectedAppUsages: connectedAppUsagesTable,
    connectedApps: connectedAppsTable,
    connectionClaims: connectionClaimsTable,
    connectorUsageBudgets: connectorUsageBudgetsTable,
    connectorUsageDimensions: connectorUsageDimensionsTable,
    connectorUsagePrices: connectorUsagePricesTable,
    designs: designsTable,
    duplicateDetectionRuns: duplicateDetectionRunsTable,
    duplicateWorkflowPairs: duplicateWorkflowPairsTable,
    duplicateWorkflowReviews: duplicateWorkflowReviewsTable,
    egressRoutes: egressRoutesTable,
    egressRules: egressRulesTable,
    executionStats: executionStatsTable,
    featureFlags: featureFlagsTable,
    gitBranchCursors: gitBranchCursorsTable,
    grantRequestGrants: grantRequestGrantsTable,
    grantRequests: grantRequestsTable,
    networkUsageBuckets: networkUsageBucketsTable,
    networks: networksTable,
    oauthClient: oauthClientTable,
    oauthClientServiceAccount: oauthClientServiceAccountTable,
    oauthConnections: oauthConnectionsTable,
    oauthGrant: oauthGrantTable,
    oidcProviders: oidcProvidersTable,
    personalChatConnectedApps: personalChatConnectedAppsTable,
    personalChats: personalChatsTable,
    personalVolumes: personalVolumesTable,
    roleGrants: roleGrantsTable,
    rolePermissions: rolePermissionsTable,
    roles: rolesTable,
    routeFavorites: routeFavoritesTable,
    routeViews: routeViewsTable,
    serviceAccountFederations: serviceAccountFederationsTable,
    serviceAccounts: serviceAccountsTable,
    skillFiles: skillFilesTable,
    skillGitInstallations: skillGitInstallationsTable,
    skillGitSources: skillGitSourcesTable,
    skills: skillsTable,
    spaceBranchMembers: spaceBranchMembersTable,
    spaceBranches: spaceBranchesTable,
    spaceGitPullRequests: spaceGitPullRequestsTable,
    spaceGitRemotes: spaceGitRemotesTable,
    spaceStorageStats: spaceStorageStatsTable,
    spaceUserStats: spaceUserStatsTable,
    spaceVolumes: spaceVolumesTable,
    spaces: spacesTable,
    ssoProvider: ssoProviderTable,
    stepActivity: stepActivityTable,
    stepTestSpecs: stepTestSpecsTable,
    systemMessages: systemMessagesTable,
    tenantCustomDomains: tenantCustomDomainsTable,
    tenantKeys: tenantKeysTable,
    tenants: tenantsTable,
    toolCalls: toolCallsTable,
    user: userTable,
    userActions: userActionsTable,
    userBranchPresence: userBranchPresenceTable,
    userGroups: userGroupsTable,
    userMessages: userMessagesTable,
    userPreferences: userPreferencesTable,
    workflowBranches: workflowBranchesTable,
    workflowCommits: workflowCommitsTable,
    workflowConnectedApps: workflowConnectedAppsTable,
    workflowFavorites: workflowFavoritesTable,
    workflowRunDailyStats: workflowRunDailyStatsTable,
    workflowRuns: workflowRunsTable,
    workflowViews: workflowViewsTable,
    workflows: workflowsTable,
  },
  relationships: {
    user: userRelationships,
    apikey: apikeyRelationships,
    ssoProvider: ssoProviderRelationships,
    spaces: spacesRelationships,
    spaceVolumes: spaceVolumesRelationships,
    spaceGitRemotes: spaceGitRemotesRelationships,
    gitBranchCursors: gitBranchCursorsRelationships,
    spaceGitPullRequests: spaceGitPullRequestsRelationships,
    spaceBranches: spaceBranchesRelationships,
    spaceBranchMembers: spaceBranchMembersRelationships,
    userBranchPresence: userBranchPresenceRelationships,
    duplicateWorkflowPairs: duplicateWorkflowPairsRelationships,
    duplicateWorkflowReviews: duplicateWorkflowReviewsRelationships,
    workflowFavorites: workflowFavoritesRelationships,
    routeFavorites: routeFavoritesRelationships,
    workflowViews: workflowViewsRelationships,
    routeViews: routeViewsRelationships,
    workflows: workflowsRelationships,
    workflowBranches: workflowBranchesRelationships,
    branchContributors: branchContributorsRelationships,
    branchModelPreferences: branchModelPreferencesRelationships,
    workflowCommits: workflowCommitsRelationships,
    workflowRuns: workflowRunsRelationships,
    oauthConnections: oauthConnectionsRelationships,
    connectedApps: connectedAppsRelationships,
    skills: skillsRelationships,
    skillFiles: skillFilesRelationships,
    skillGitSources: skillGitSourcesRelationships,
    skillGitInstallations: skillGitInstallationsRelationships,
    designs: designsRelationships,
    chats: chatsRelationships,
    personalChats: personalChatsRelationships,
    chatEntries: chatEntriesRelationships,
    userMessages: userMessagesRelationships,
    userActions: userActionsRelationships,
    commitFiles: commitFilesRelationships,
    commitRoutes: commitRoutesRelationships,
    commitDependencies: commitDependenciesRelationships,
    commitSchedules: commitSchedulesRelationships,
    commitEmailAddresses: commitEmailAddressesRelationships,
    commitLinks: commitLinksRelationships,
    networks: networksRelationships,
    egressRoutes: egressRoutesRelationships,
    egressRules: egressRulesRelationships,
    connectionClaims: connectionClaimsRelationships,
    grantRequests: grantRequestsRelationships,
    stepActivity: stepActivityRelationships,
    spaceUserStats: spaceUserStatsRelationships,
    spaceStorageStats: spaceStorageStatsRelationships,
    workflowRunDailyStats: workflowRunDailyStatsRelationships,
    executionStats: executionStatsRelationships,
    networkUsageBuckets: networkUsageBucketsRelationships,
    featureFlags: featureFlagsRelationships,
    auditLogs: auditLogsRelationships,
    auditLogDestinations: auditLogDestinationsRelationships,
    connectedAppUsages: connectedAppUsagesRelationships,
    aiProviders: aiProvidersRelationships,
    aiUsageDaily: aiUsageDailyRelationships,
    connectorUsageDimensions: connectorUsageDimensionsRelationships,
    aiModelPricing: aiModelPricingRelationships,
    aiBudgets: aiBudgetsRelationships,
    userGroups: userGroupsRelationships,
    serviceAccounts: serviceAccountsRelationships,
    serviceAccountFederations: serviceAccountFederationsRelationships,
    oidcProviders: oidcProvidersRelationships,
    oauthClient: oauthClientRelationships,
    oauthClientServiceAccount: oauthClientServiceAccountRelationships,
    oauthGrant: oauthGrantRelationships,
    roles: rolesRelationships,
    roleGrants: roleGrantsRelationships,
  },
  enableLegacyQueries: false,
  enableLegacyMutators: false,
} as const;

/**
 * Represents the Zero schema type.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type Schema = typeof schema;
/**
 * Represents a row from the "aiBudgets" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type AiBudget = Row<(typeof schema)["tables"]["aiBudgets"]>;
/**
 * Represents a row from the "aiModelPricing" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type AiModelPricing = Row<(typeof schema)["tables"]["aiModelPricing"]>;
/**
 * Represents a row from the "aiProviders" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type AiProvider = Row<(typeof schema)["tables"]["aiProviders"]>;
/**
 * Represents a row from the "aiUsageDaily" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type AiUsageDaily = Row<(typeof schema)["tables"]["aiUsageDaily"]>;
/**
 * Represents a row from the "apikey" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type Apikey = Row<(typeof schema)["tables"]["apikey"]>;
/**
 * Represents a row from the "assistantMessages" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type AssistantMessage = Row<
  (typeof schema)["tables"]["assistantMessages"]
>;
/**
 * Represents a row from the "assistantReasonings" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type AssistantReasoning = Row<
  (typeof schema)["tables"]["assistantReasonings"]
>;
/**
 * Represents a row from the "attachments" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type Attachment = Row<(typeof schema)["tables"]["attachments"]>;
/**
 * Represents a row from the "auditLogDestinations" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type AuditLogDestination = Row<
  (typeof schema)["tables"]["auditLogDestinations"]
>;
/**
 * Represents a row from the "auditLogs" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type AuditLog = Row<(typeof schema)["tables"]["auditLogs"]>;
/**
 * Represents a row from the "blobs" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type Blob = Row<(typeof schema)["tables"]["blobs"]>;
/**
 * Represents a row from the "branchContributors" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type BranchContributor = Row<
  (typeof schema)["tables"]["branchContributors"]
>;
/**
 * Represents a row from the "branchModelPreferences" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type BranchModelPreference = Row<
  (typeof schema)["tables"]["branchModelPreferences"]
>;
/**
 * Represents a row from the "buildCaches" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type BuildCach = Row<(typeof schema)["tables"]["buildCaches"]>;
/**
 * Represents a row from the "chatEntries" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type ChatEntry = Row<(typeof schema)["tables"]["chatEntries"]>;
/**
 * Represents a row from the "chats" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type Chat = Row<(typeof schema)["tables"]["chats"]>;
/**
 * Represents a row from the "commitConnectedApps" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type CommitConnectedApp = Row<
  (typeof schema)["tables"]["commitConnectedApps"]
>;
/**
 * Represents a row from the "commitDependencies" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type CommitDependency = Row<
  (typeof schema)["tables"]["commitDependencies"]
>;
/**
 * Represents a row from the "commitEmailAddresses" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type CommitEmailAddress = Row<
  (typeof schema)["tables"]["commitEmailAddresses"]
>;
/**
 * Represents a row from the "commitFiles" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type CommitFile = Row<(typeof schema)["tables"]["commitFiles"]>;
/**
 * Represents a row from the "commitLinks" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type CommitLink = Row<(typeof schema)["tables"]["commitLinks"]>;
/**
 * Represents a row from the "commitRoutes" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type CommitRoute = Row<(typeof schema)["tables"]["commitRoutes"]>;
/**
 * Represents a row from the "commitSchedules" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type CommitSchedule = Row<(typeof schema)["tables"]["commitSchedules"]>;
/**
 * Represents a row from the "commitStepLayers" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type CommitStepLayer = Row<
  (typeof schema)["tables"]["commitStepLayers"]
>;
/**
 * Represents a row from the "compactions" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type Compaction = Row<(typeof schema)["tables"]["compactions"]>;
/**
 * Represents a row from the "connectedAppUsages" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type ConnectedAppUsage = Row<
  (typeof schema)["tables"]["connectedAppUsages"]
>;
/**
 * Represents a row from the "connectedApps" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type ConnectedApp = Row<(typeof schema)["tables"]["connectedApps"]>;
/**
 * Represents a row from the "connectionClaims" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type ConnectionClaim = Row<
  (typeof schema)["tables"]["connectionClaims"]
>;
/**
 * Represents a row from the "connectorUsageBudgets" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type ConnectorUsageBudget = Row<
  (typeof schema)["tables"]["connectorUsageBudgets"]
>;
/**
 * Represents a row from the "connectorUsageDimensions" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type ConnectorUsageDimension = Row<
  (typeof schema)["tables"]["connectorUsageDimensions"]
>;
/**
 * Represents a row from the "connectorUsagePrices" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type ConnectorUsagePrice = Row<
  (typeof schema)["tables"]["connectorUsagePrices"]
>;
/**
 * Represents a row from the "designs" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type Design = Row<(typeof schema)["tables"]["designs"]>;
/**
 * Represents a row from the "duplicateDetectionRuns" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type DuplicateDetectionRun = Row<
  (typeof schema)["tables"]["duplicateDetectionRuns"]
>;
/**
 * Represents a row from the "duplicateWorkflowPairs" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type DuplicateWorkflowPair = Row<
  (typeof schema)["tables"]["duplicateWorkflowPairs"]
>;
/**
 * Represents a row from the "duplicateWorkflowReviews" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type DuplicateWorkflowReview = Row<
  (typeof schema)["tables"]["duplicateWorkflowReviews"]
>;
/**
 * Represents a row from the "egressRoutes" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type EgressRoute = Row<(typeof schema)["tables"]["egressRoutes"]>;
/**
 * Represents a row from the "egressRules" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type EgressRule = Row<(typeof schema)["tables"]["egressRules"]>;
/**
 * Represents a row from the "executionStats" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type ExecutionStat = Row<(typeof schema)["tables"]["executionStats"]>;
/**
 * Represents a row from the "featureFlags" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type FeatureFlag = Row<(typeof schema)["tables"]["featureFlags"]>;
/**
 * Represents a row from the "gitBranchCursors" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type GitBranchCursor = Row<
  (typeof schema)["tables"]["gitBranchCursors"]
>;
/**
 * Represents a row from the "grantRequestGrants" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type GrantRequestGrant = Row<
  (typeof schema)["tables"]["grantRequestGrants"]
>;
/**
 * Represents a row from the "grantRequests" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type GrantRequest = Row<(typeof schema)["tables"]["grantRequests"]>;
/**
 * Represents a row from the "networkUsageBuckets" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type NetworkUsageBucket = Row<
  (typeof schema)["tables"]["networkUsageBuckets"]
>;
/**
 * Represents a row from the "networks" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type Network = Row<(typeof schema)["tables"]["networks"]>;
/**
 * Represents a row from the "oauthClient" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type OauthClient = Row<(typeof schema)["tables"]["oauthClient"]>;
/**
 * Represents a row from the "oauthClientServiceAccount" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type OauthClientServiceAccount = Row<
  (typeof schema)["tables"]["oauthClientServiceAccount"]
>;
/**
 * Represents a row from the "oauthConnections" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type OauthConnection = Row<
  (typeof schema)["tables"]["oauthConnections"]
>;
/**
 * Represents a row from the "oauthGrant" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type OauthGrant = Row<(typeof schema)["tables"]["oauthGrant"]>;
/**
 * Represents a row from the "oidcProviders" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type OidcProvider = Row<(typeof schema)["tables"]["oidcProviders"]>;
/**
 * Represents a row from the "personalChatConnectedApps" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type PersonalChatConnectedApp = Row<
  (typeof schema)["tables"]["personalChatConnectedApps"]
>;
/**
 * Represents a row from the "personalChats" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type PersonalChat = Row<(typeof schema)["tables"]["personalChats"]>;
/**
 * Represents a row from the "personalVolumes" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type PersonalVolume = Row<(typeof schema)["tables"]["personalVolumes"]>;
/**
 * Represents a row from the "roleGrants" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type RoleGrant = Row<(typeof schema)["tables"]["roleGrants"]>;
/**
 * Represents a row from the "rolePermissions" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type RolePermission = Row<(typeof schema)["tables"]["rolePermissions"]>;
/**
 * Represents a row from the "roles" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type Role = Row<(typeof schema)["tables"]["roles"]>;
/**
 * Represents a row from the "routeFavorites" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type RouteFavorite = Row<(typeof schema)["tables"]["routeFavorites"]>;
/**
 * Represents a row from the "routeViews" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type RouteView = Row<(typeof schema)["tables"]["routeViews"]>;
/**
 * Represents a row from the "serviceAccountFederations" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type ServiceAccountFederation = Row<
  (typeof schema)["tables"]["serviceAccountFederations"]
>;
/**
 * Represents a row from the "serviceAccounts" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type ServiceAccount = Row<(typeof schema)["tables"]["serviceAccounts"]>;
/**
 * Represents a row from the "skillFiles" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type SkillFile = Row<(typeof schema)["tables"]["skillFiles"]>;
/**
 * Represents a row from the "skillGitInstallations" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type SkillGitInstallation = Row<
  (typeof schema)["tables"]["skillGitInstallations"]
>;
/**
 * Represents a row from the "skillGitSources" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type SkillGitSource = Row<(typeof schema)["tables"]["skillGitSources"]>;
/**
 * Represents a row from the "skills" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type Skill = Row<(typeof schema)["tables"]["skills"]>;
/**
 * Represents a row from the "spaceBranchMembers" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type SpaceBranchMember = Row<
  (typeof schema)["tables"]["spaceBranchMembers"]
>;
/**
 * Represents a row from the "spaceBranches" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type SpaceBranch = Row<(typeof schema)["tables"]["spaceBranches"]>;
/**
 * Represents a row from the "spaceGitPullRequests" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type SpaceGitPullRequest = Row<
  (typeof schema)["tables"]["spaceGitPullRequests"]
>;
/**
 * Represents a row from the "spaceGitRemotes" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type SpaceGitRemote = Row<(typeof schema)["tables"]["spaceGitRemotes"]>;
/**
 * Represents a row from the "spaceStorageStats" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type SpaceStorageStat = Row<
  (typeof schema)["tables"]["spaceStorageStats"]
>;
/**
 * Represents a row from the "spaceUserStats" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type SpaceUserStat = Row<(typeof schema)["tables"]["spaceUserStats"]>;
/**
 * Represents a row from the "spaceVolumes" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type SpaceVolume = Row<(typeof schema)["tables"]["spaceVolumes"]>;
/**
 * Represents a row from the "spaces" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type Space = Row<(typeof schema)["tables"]["spaces"]>;
/**
 * Represents a row from the "ssoProvider" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type SsoProvider = Row<(typeof schema)["tables"]["ssoProvider"]>;
/**
 * Represents a row from the "stepActivity" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type StepActivity = Row<(typeof schema)["tables"]["stepActivity"]>;
/**
 * Represents a row from the "stepTestSpecs" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type StepTestSpec = Row<(typeof schema)["tables"]["stepTestSpecs"]>;
/**
 * Represents a row from the "systemMessages" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type SystemMessage = Row<(typeof schema)["tables"]["systemMessages"]>;
/**
 * Represents a row from the "tenantCustomDomains" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type TenantCustomDomain = Row<
  (typeof schema)["tables"]["tenantCustomDomains"]
>;
/**
 * Represents a row from the "tenantKeys" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type TenantKey = Row<(typeof schema)["tables"]["tenantKeys"]>;
/**
 * Represents a row from the "tenants" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type Tenant = Row<(typeof schema)["tables"]["tenants"]>;
/**
 * Represents a row from the "toolCalls" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type ToolCall = Row<(typeof schema)["tables"]["toolCalls"]>;
/**
 * Represents a row from the "user" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type User = Row<(typeof schema)["tables"]["user"]>;
/**
 * Represents a row from the "userActions" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type UserAction = Row<(typeof schema)["tables"]["userActions"]>;
/**
 * Represents a row from the "userBranchPresence" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type UserBranchPresence = Row<
  (typeof schema)["tables"]["userBranchPresence"]
>;
/**
 * Represents a row from the "userGroups" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type UserGroup = Row<(typeof schema)["tables"]["userGroups"]>;
/**
 * Represents a row from the "userMessages" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type UserMessage = Row<(typeof schema)["tables"]["userMessages"]>;
/**
 * Represents a row from the "userPreferences" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type UserPreference = Row<(typeof schema)["tables"]["userPreferences"]>;
/**
 * Represents a row from the "workflowBranches" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type WorkflowBranch = Row<(typeof schema)["tables"]["workflowBranches"]>;
/**
 * Represents a row from the "workflowCommits" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type WorkflowCommit = Row<(typeof schema)["tables"]["workflowCommits"]>;
/**
 * Represents a row from the "workflowConnectedApps" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type WorkflowConnectedApp = Row<
  (typeof schema)["tables"]["workflowConnectedApps"]
>;
/**
 * Represents a row from the "workflowFavorites" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type WorkflowFavorite = Row<
  (typeof schema)["tables"]["workflowFavorites"]
>;
/**
 * Represents a row from the "workflowRunDailyStats" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type WorkflowRunDailyStat = Row<
  (typeof schema)["tables"]["workflowRunDailyStats"]
>;
/**
 * Represents a row from the "workflowRuns" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type WorkflowRun = Row<(typeof schema)["tables"]["workflowRuns"]>;
/**
 * Represents a row from the "workflowViews" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type WorkflowView = Row<(typeof schema)["tables"]["workflowViews"]>;
/**
 * Represents a row from the "workflows" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type Workflow = Row<(typeof schema)["tables"]["workflows"]>;

/**
 * Represents the ZQL query builder.
 * This type is auto-generated from your Drizzle schema definition.
 */
export const zql = createBuilder(schema);
/**
 * Represents the Zero schema query builder.
 * This type is auto-generated from your Drizzle schema definition.
 */
export const builder = zql;

/** Defines the default types for Zero */
declare module "@rocicorp/zero" {
  interface DefaultTypes {
    schema: Schema;
  }
}
